(function () {
  'use strict';

  var DCF_BASE = 'https://diecutflow.replit.app';
  var _sampleRequested = false;
  var _sampleOffer = null;
  var _dealRecipe = null;

  function _getWidgetData(attr) {
    var el = document.getElementById('air-freshener-widget');
    return el ? (el.getAttribute(attr) || '') : '';
  }

  var _FALLBACK_FRAGRANCES = [
    { key: 'new_car', label: 'New Car' },
    { key: 'black_ice', label: 'Black Ice' },
    { key: 'cherry', label: 'Cherry' },
    { key: 'citrus', label: 'Citrus' },
    { key: 'coconut', label: 'Coconut' },
    { key: 'coffee', label: 'Coffee' },
    { key: 'cucumber_mint', label: 'Cucumber Mint' },
    { key: 'pine', label: 'Pine' },
    { key: 'big_sur', label: 'Big Sur' },
    { key: 'rain_forest', label: 'Rain Forest' },
    { key: 'sunshine_coast', label: 'Sunshine Coast' },
    { key: 'unscented', label: 'Unscented' }
  ];

  var FRAGRANCES = [];
  var _configLoaded = false;

  var _nativeRateContract = null;
  var _productContract = null;
  var _productContractRow = null;
  var _packagingArtwork = {
    header: null,
    backerFront: null,
    backerBack: null
  };

  function _fetchNativeRateContract() {
    var url = _getWidgetData('data-native-rate-contract-url');
    if (!url || !window.ZUGAirFreshenerNativeRate) {
      return Promise.reject(new Error('Air Freshener native-rate engine is unavailable.'));
    }
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Air Freshener native-rate contract failed to load.');
      return response.json();
    }).then(function (raw) {
      _nativeRateContract = window.ZUGAirFreshenerNativeRate.prepare(raw);
      return _nativeRateContract;
    });
  }

  function _fetchProductContract() {
    var url = _getWidgetData('data-product-contract-url');
    if (!url || !window.ZUGAirFreshenerProductContract) {
      return Promise.reject(new Error('Air Freshener product contract engine is unavailable.'));
    }
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Air Freshener product contract failed to load.');
      return response.json();
    }).then(function (raw) {
      _productContract = window.ZUGAirFreshenerProductContract.prepare(raw);
      _productContractRow = _dealRecipe && _dealRecipe.key === '50FOR99'
        ? window.ZUGAirFreshenerDealRecipes.productRow(_dealRecipe)
        : window.ZUGAirFreshenerProductContract.resolveProduct(
          _productContract,
          _getWidgetData('data-product-id'),
          _getWidgetData('data-product-handle')
        );
      return _productContractRow;
    });
  }

  var AF_FRAGRANCE_UPCHARGE_CENTS = 300;
  var AF_DOUBLE_IMAGE_FEE_CENTS = 500;

  function _generateCalcLineUid() {
    return 'af-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 8);
  }

  function _applySourceProduct(properties) {
    var title = _getWidgetData('data-product-title') || 'Custom Air Fresheners';
    var carrierTitle = _nativeRateContract && _nativeRateContract.product
      ? _nativeRateContract.product.title
      : 'Custom Air Fresheners';
    properties._product_title = title;
    properties._storefront_product_url = _getWidgetData('data-product-url') || '';
    properties._storefront_product_image = _getWidgetData('data-product-image') || '';
    if (title.trim().toLowerCase() !== carrierTitle.trim().toLowerCase()) {
      properties.Product = title;
    }
    return properties;
  }

  async function _rollbackNativeLine(calcLineUid) {
    try {
      var cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok) return;
      var cart = await cartResponse.json();
      var line = cart.items.find(function (item) {
        return item.properties && item.properties._calc_line_uid === calcLineUid;
      });
      if (!line) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
    } catch (rollbackError) {
      console.error('[ZUG-AF] native-line rollback failed', rollbackError);
    }
  }

  async function _addNativeLine(properties, totalDesiredCents, calcLineUid) {
    if (!_nativeRateContract || !_productContract || !_productContractRow ||
        !window.ZUGAirFreshenerNativeRate) {
      throw new Error('Air Freshener native pricing is unavailable.');
    }

    var built = window.ZUGAirFreshenerNativeRate.buildLine({
      contract: _nativeRateContract,
      productContract: _productContract,
      sourceProductId: _getWidgetData('data-product-id'),
      sourceProductHandle: _getWidgetData('data-product-handle'),
      totalCents: totalDesiredCents,
      uid: calcLineUid,
      pieces: _state.quantity,
      fragrances: _state.selectedFragrances.map(function (key) { return _fragranceLabel(key); }),
      doubleImage: _state.printStyle === 'double',
      dealRecipe: _dealRecipe,
      properties: properties
    });
    var addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [built.item] })
    });
    if (!addResponse.ok) {
      var addError = await addResponse.json().catch(function () { return {}; });
      throw new Error(addError.description || addError.message || 'Cart API error');
    }

    try {
      var cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok) {
        throw new Error('Air Freshener cart verification failed.');
      }
      var cart = await cartResponse.json();
      var matching = cart.items.filter(function (item) {
        return item.properties && item.properties._calc_line_uid === calcLineUid;
      });
      var expectedPieces = built.productionQuantities
        ? built.productionQuantities.total
        : _state.quantity;
      if (matching.length !== 1 || !window.ZUGAirFreshenerNativeRate.verifyCartLine(
        matching[0], built.resolution, calcLineUid, expectedPieces
      )) {
        throw new Error('Air Freshener price assertion failed.');
      }
    } catch (verificationError) {
      await _rollbackNativeLine(calcLineUid);
      throw new Error(verificationError.message + ' The added line was removed.');
    }
    return built;
  }

  function _deriveAssetBase() {
    var url = _getWidgetData('data-pe-url') || _getWidgetData('data-config-url') || '';
    var idx = url.lastIndexOf('/');
    return idx > 0 ? url.substring(0, idx + 1) : '';
  }

  function _useFallbackFragrances() {
    var assetBase = _deriveAssetBase();
    var imageMap = {
      new_car: 'AF-new-car-smell-scent-custom-air-frasheners.jpg',
      black_ice: 'AF-BLACK-ICE-scent-custom-air-frasheners.jpg',
      cherry: 'AF-cherry-scent-custom-air-frasheners.jpg',
      citrus: 'AF-Citrus-scent-custom-air-frasheners.jpg',
      coconut: 'AF-Coconut-scent-custom-air-frasheners.jpg',
      coffee: 'AF-coffee-scent-custom-air-frasheners.jpg',
      cucumber_mint: 'AF-Cucumber-Mint-scent-custom-air-frasheners.jpg',
      pine: 'AF-pine-scent-custom-air-frasheners.jpg',
      big_sur: 'AF-big-sur-scent-custom-air-frasheners.jpg',
      rain_forest: 'AF-rain-forest-scent-custom-air-frasheners.jpg',
      sunshine_coast: 'AF-sunshine-coast-scent-custom-air-frasheners.jpg',
      unscented: 'AF-uncented-custom-air-frasheners.jpg'
    };
    FRAGRANCES = _FALLBACK_FRAGRANCES.map(function (f) {
      return { key: f.key, label: f.label, image: assetBase + (imageMap[f.key] || ''), sold_out: false };
    });
  }

  function _loadFragranceConfig() {
    var configUrl = _getWidgetData('data-config-url');
    if (!configUrl) {
      console.warn('[ZUG-AF] No config URL, using fallback fragrances');
      _useFallbackFragrances();
      return Promise.resolve();
    }
    return fetch(configUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.fragrances) || data.fragrances.length === 0) {
          throw new Error('Invalid or empty config');
        }
        var assetBase = _deriveAssetBase();
        var items = data.fragrances
          .filter(function (f) { return f.id && f.label && f.enabled !== false; })
          .sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
        if (items.length === 0) throw new Error('No enabled fragrances');
        FRAGRANCES = items
          .filter(function (f) { return !f.backordered; })
          .map(function (f) {
          return {
            key: f.id,
            label: f.label,
            image: f.image ? (assetBase + f.image) : '',
            sold_out: !!f.sold_out
          };
        });
        _configLoaded = true;
      })
      .catch(function (err) {
        console.warn('[ZUG-AF] Config load failed, using fallback:', err);
        _useFallbackFragrances();
      });
  }

  function _renderFragranceButtons() {
    var container = document.getElementById('af-fragrance-buttons');
    if (!container) return;
    container.innerHTML = '';
    var firstEnabled = null;
    FRAGRANCES.forEach(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'af-widget__scent-btn';
      btn.setAttribute('data-fragrance', f.key);
      btn.title = f.label;
      if (f.sold_out) {
        btn.classList.add('af-widget__scent-btn--sold-out');
        btn.disabled = true;
      }
      if (!f.sold_out && !firstEnabled) firstEnabled = f;
      if (f.key === _state.fragrance && !f.sold_out) {
        btn.classList.add('af-widget__scent-btn--active');
      }
      if (f.image) {
        var img = document.createElement('img');
        img.src = f.image;
        img.alt = f.label;
        img.width = 80;
        img.height = 80;
        img.loading = 'lazy';
        btn.appendChild(img);
      }
      var lbl = document.createElement('span');
      lbl.className = 'af-widget__scent-btn__label';
      lbl.textContent = f.label;
      btn.appendChild(lbl);
      container.appendChild(btn);
    });
    if (_state.fragrance) {
      var current = FRAGRANCES.find(function (f) { return f.key === _state.fragrance && !f.sold_out; });
      if (!current && firstEnabled) {
        _state.fragrance = firstEnabled.key;
        var activeBtn = container.querySelector('[data-fragrance="' + firstEnabled.key + '"]');
        if (activeBtn) activeBtn.classList.add('af-widget__scent-btn--active');
      }
    }
    var valEl = document.getElementById('af-fragrance-value');
    if (valEl) valEl.textContent = _fragranceLabel(_state.fragrance);
  }

  var SHAPES = {
    oval: {
      key: 'oval',
      label: 'Oval',
      width_in: 3,
      height_in: 4,
      cornerRadius: 0,
      maskType: 'ellipse',
      maskConfig: function (cw, ch) {
        var ref = Math.min(cw, ch);
        var r = ref * 0.42;
        return { type: 'ellipse', rx: r, ry: r };
      }
    },
    circle: {
      key: 'circle',
      label: 'Circle',
      width_in: 3.2,
      height_in: 3.2,
      cornerRadius: 0,
      maskType: 'ellipse',
      maskConfig: function (cw, ch) {
        var ref = Math.min(cw, ch);
        var r = ref * 0.42;
        return { type: 'ellipse', rx: r, ry: r };
      }
    },
    square: {
      key: 'square',
      label: 'Square',
      width_in: 3,
      height_in: 3,
      cornerRadius: 0.17,
      maskType: 'rounded-rect',
      maskConfig: function (cw, ch) {
        var ref = Math.min(cw, ch);
        var s = ref * 0.82;
        return { type: 'rect', width: s, height: s, rx: ref * 0.047 };
      }
    },
    rectangle: {
      key: 'rectangle',
      label: 'Rectangle',
      width_in: 2.5,
      height_in: 4,
      cornerRadius: 0.25,
      maskType: 'rounded-rect',
      maskConfig: function (cw, ch) {
        var w = cw * 0.82;
        var h = ch * 0.82;
        var ref = Math.min(cw, ch);
        return { type: 'rect', width: w, height: h, rx: ref * 0.065 };
      }
    },
    die_cut: {
      key: 'die_cut',
      label: 'Custom Shape',
      width_in: 3.0,
      height_in: 4.0,
      maskType: 'path',
      maskConfig: function (cw, ch) {
        return { type: 'path', width: cw * 0.82, height: ch * 0.82 };
      }
    }
  };

  var AF_MAX_FINISHED_W_IN = 3.0;
  var AF_MAX_FINISHED_H_IN = 4.0;
  var AF_HANGER_TOTAL_H_IN = 0.65;
  var AF_HANGER_STICKOUT_IN = 0.18;
  var AF_HANGER_MARGIN_IN = 0.05;
  var AF_HANGER_SVG_VB_W = 45;
  var AF_HANGER_SVG_VB_H = 98.6;
  var AF_HANGER_HUMP_TOP_Y = 52.0;
  var _hangResizeObs = null;

  function _computeThicknessPx() {
    var bw = _state.dieCut.bbox_width_px;
    var bh = _state.dieCut.bbox_height_px;
    var pw = _state.dieCut.dcfPhysicalW || AF_MAX_FINISHED_W_IN;
    var ph = _state.dieCut.dcfPhysicalH || AF_MAX_FINISHED_H_IN;
    if (!bw || !bh || !pw || !ph) return Math.round(_state.borderSize * (800 / AF_MAX_FINISHED_W_IN));
    var pxPerIn = Math.min(bw / pw, bh / ph);
    return Math.round(_state.borderSize * pxPerIn);
  }

  function _setBuilderLoading(on) {
    var previewLoading = document.getElementById('zug-af-preview-loading');
    if (previewLoading) previewLoading.style.display = on ? 'flex' : 'none';
    var builderLoader = document.querySelector('#zug-af-preview-loading .zug-preview-loader');
    if (builderLoader) {
      if (on) builderLoader.classList.add('active');
      else builderLoader.classList.remove('active');
    }
  }

  async function _callDCFPreview(file) {
    var thicknessPx = _computeThicknessPx();
    var removeBg = _state.dieCut.removeBg;
    var fillRadio = document.querySelector('input[name="zug-af-fill"]:checked');
    var fillMode = (fillRadio && fillRadio.value === 'solid') ? 'solid' : 'original';
    var fillColor = _state.fillColor || '#ffffff';

    console.log('[ZUG-AF-DC] calling DCF', { shape: _state.shape, thicknessPx: thicknessPx, removeBg: removeBg, fillMode: fillMode });

    if (_state.shape === 'die_cut') {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('outline_color', '#FFFFFF');
      formData.append('outline_thickness_px', String(thicknessPx));
      formData.append('remove_bg', removeBg ? 'true' : 'false');
      formData.append('fill_mode', fillMode);
      formData.append('fill_color', fillColor);
      formData.append('target_width_in', String(AF_MAX_FINISHED_W_IN));
      formData.append('target_height_in', String(AF_MAX_FINISHED_H_IN));

      var resp = await fetch(DCF_BASE + '/preview', { method: 'POST', body: formData });
      if (!resp.ok) throw new Error('DCF preview failed: ' + resp.status);
      var data = await resp.json();
      console.log('[ZUG-AF-DC] /preview response keys:', Object.keys(data));

      var src = data.source || {};
      return {
        preview_url: data.preview_url,
        artwork_url: data.artwork_png_url || data.artwork_url || data.original_url || null,
        original_url: data.original_url || null,
        preview_id: data.preview_id,
        cutline_svg_path: data.cutline_svg_path,
        physical_width_in: (data.physical && data.physical.width_in) || data.physical_width_in,
        physical_height_in: (data.physical && data.physical.height_in) || data.physical_height_in,
        bbox_width_px: data.bbox_width_px,
        bbox_height_px: data.bbox_height_px,
        bbox_x_px: data.bbox_x_px,
        bbox_y_px: data.bbox_y_px,
        source_width_px: data.source_width_px || src.width_px,
        source_height_px: data.source_height_px || src.height_px
      };
    }

    var fd = new FormData();
    fd.append('file', file);
    fd.append('product_code', 'sticker_gl');
    fd.append('options.shape_mode', _state.shape);
    fd.append('options.target_width_in', String(AF_MAX_FINISHED_W_IN));
    fd.append('options.target_height_in', String(AF_MAX_FINISHED_H_IN));
    fd.append('options.border_thickness_px', String(thicknessPx));
    fd.append('options.border_color', '#FFFFFF');
    fd.append('options.remove_bg', removeBg ? 'true' : 'false');
    fd.append('options.fill_mode', fillMode);
    if (fillMode === 'solid' && fillColor) {
      fd.append('options.fill_color', fillColor);
    }
    var shapeObj = SHAPES[_state.shape];
    if (shapeObj && shapeObj.cornerRadius) {
      fd.append('options.corner_radius_in', String(shapeObj.cornerRadius));
    }

    var resp2 = await fetch(DCF_BASE + '/v1/preview-job', { method: 'POST', body: fd });
    if (!resp2.ok) throw new Error('DCF preview-job failed: ' + resp2.status);
    var data2 = await resp2.json();
    console.log('[ZUG-AF-DC] /v1/preview-job response keys:', Object.keys(data2));

    var paths = data2.paths || {};
    var phys = data2.physical || {};
    var src2 = data2.source || {};
    return {
      preview_url: paths.preview || data2.preview_url,
      artwork_url: paths.artwork || data2.artwork_png_url || data2.artwork_url || paths.original || null,
      original_url: paths.original || data2.original_url || null,
      preview_id: data2.job_id,
      cutline_svg_path: data2.cutline_svg_path,
      physical_width_in: phys.width_in || data2.physical_width_in,
      physical_height_in: phys.height_in || data2.physical_height_in,
      bbox_width_px: data2.bbox_width_px,
      bbox_height_px: data2.bbox_height_px,
      bbox_x_px: data2.bbox_x_px,
      bbox_y_px: data2.bbox_y_px,
      source_width_px: data2.source_width_px || src2.width_px,
      source_height_px: data2.source_height_px || src2.height_px
    };
  }

  function _applyDCFResponse(data) {
    if (!data) return;
    _state.previewUrl = data.preview_url || null;
    _state.artworkUrl = data.artwork_url || null;
    _state.dieCut.dcfUploadId = data.preview_id || null;
    _state.dieCut.dcfOriginalUrl = data.original_url || null;
    _state.dieCut.processedArtworkUrl = data.artwork_url || null;
    _state.dieCut.dcfCutlinePath = data.cutline_svg_path || null;
    _state.dieCut.cutline_svg_path = data.cutline_svg_path || null;
    _state.dieCut.dcfPhysicalW = data.physical_width_in || null;
    _state.dieCut.dcfPhysicalH = data.physical_height_in || null;
    _state.dieCut.bbox_x_px = data.bbox_x_px || 0;
    _state.dieCut.bbox_y_px = data.bbox_y_px || 0;
    _state.dieCut.bbox_width_px = data.bbox_width_px || data.source_width_px || 800;
    _state.dieCut.bbox_height_px = data.bbox_height_px || data.source_height_px || 800;
    _state.dieCut.source_width_px = data.source_width_px || null;
    _state.dieCut.source_height_px = data.source_height_px || null;
    _state.dieCut.contourReady = true;
    console.log('[ZUG-AF-DC] DCF response applied', { previewUrl: _state.previewUrl, cutline: !!data.cutline_svg_path });
  }

  function _refreshPreview() {
    if (!_state.front.file) return;
    if (_state._dcfLoading) {
      _state._refreshQueued = true;
      return;
    }
    if (_state._refreshDebounce) clearTimeout(_state._refreshDebounce);
    _state._refreshDebounce = setTimeout(function () {
      _state._refreshDebounce = null;
      _doRefreshPreview();
    }, 300);
  }

  function _renderSimpleShapePreview() {
    return new Promise(function (resolve, reject) {
      var shapeData = _generateShapeCutlinePath();
      if (!shapeData || !shapeData.path) { reject(new Error('No shape path')); return; }
      var src = _state.front.originalDataUrl || _state.front.imageUrl;
      if (!src) { reject(new Error('No front image')); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var sz = 800;
        var c = document.createElement('canvas');
        c.width = sz; c.height = sz;
        var ctx = c.getContext('2d');
        var fillRadio = document.querySelector('input[name="zug-af-fill"]:checked');
        var fillMode = (fillRadio && fillRadio.value === 'solid') ? 'solid' : 'original';
        var fillColor = _state.fillColor || '#ffffff';
        var p2d = new Path2D(shapeData.path);
        if (fillMode === 'solid' && fillColor) {
          ctx.save();
          ctx.fillStyle = fillColor;
          ctx.fill(p2d);
          ctx.restore();
        }
        ctx.save();
        ctx.clip(p2d);
        var bx = shapeData.bbox_x, by = shapeData.bbox_y, bw = shapeData.bbox_w, bh = shapeData.bbox_h;
        var imgAspect = img.naturalWidth / img.naturalHeight;
        var boxAspect = bw / bh;
        var dw, dh, dx, dy;
        if (imgAspect > boxAspect) {
          dh = bh; dw = bh * imgAspect;
          dx = bx + (bw - dw) / 2; dy = by;
        } else {
          dw = bw; dh = bw / imgAspect;
          dx = bx; dy = by + (bh - dh) / 2;
        }
        ctx.drawImage(img, dx, dy, dw, dh);
        ctx.restore();
        
        var dataUrl = c.toDataURL('image/png');
        _state.front.imageUrl = dataUrl;
        _state.previewUrl = dataUrl;
        _state.dieCut.contourReady = false;
        _state.dieCut.source_width_px = img.naturalWidth;
        _state.dieCut.source_height_px = img.naturalHeight;
        resolve(dataUrl);
      };
      img.onerror = function () { reject(new Error('Image load failed')); };
      img.src = src;
    });
  }

  async function _doRefreshPreview() {
    if (!_state.front.file) return;
    console.log('[ZUG-AF-SHAPE] _doRefreshPreview start | shape:', _state.shape, '| activeSide:', _state.activeSide);
    _state._dcfLoading = true;
    _state._refreshQueued = false;
    _setBuilderLoading(true);
    try {
      if (_state.shape === 'die_cut') {
        var data = await _callDCFPreview(_state.front.file);
        if (!data) throw new Error('No response from DCF');
        _applyDCFResponse(data);
      } else {
        await _renderSimpleShapePreview();
      }
      var displayUrl = _state.previewUrl || _state.front.imageUrl;
      if (displayUrl) {
        _state.front.imageUrl = displayUrl;
        if (_state.activeSide !== 'back') {
          _showPreviewImage(displayUrl);
        }
      }
      _updateCutlineOverlay();
      _updateDimensionBadges();
      _updateStatusBar();
      _updateGating();
      if (_state.printStyle === 'mirrored' && _state.shape === 'die_cut') {
        _renderMirroredBack();
      }
      if (_state._backEditor) {
        try { _state._backEditor.canvas.dispose(); } catch (e) {}
        _state._backEditor = null;
        _state._backEditorReady = false;
        _state._backBgShape = null;
        _state._presetBackBodyFill = null;
      }
      if (_state._frontEditor) {
        try { _state._frontEditor.canvas.dispose(); } catch (e) {}
        _state._frontEditor = null;
        _state._frontEditorReady = false;
        _state._frontBgShape = null;
        _state._presetBodyFill = null;
      }
      _hideFrontEditor();
      if (_state.shape !== 'die_cut' && _state.front.originalDataUrl) {
        _initFrontPlacementEditor();
      }
      _syncSideToggle();
    } catch (err) {
      console.error('[ZUG-AF-DC] refresh failed:', err);
    }
    _state._dcfLoading = false;
    _setBuilderLoading(false);
    if (_state._refreshQueued) {
      _state._refreshQueued = false;
      _doRefreshPreview();
    }
  }

  var MIN_QTY = 1;

  function getPricing(qty) {
    if (_sampleRequested) {
      if (!_sampleOffer || !window.ZUGSampleMode) return null;
      return window.ZUGSampleMode.exactPrice(_sampleOffer);
    }
    if (_dealRecipe && _dealRecipe.key === '50FOR99') {
      if (!window.ZUGAirFreshenerDealRecipes) return null;
      return window.ZUGAirFreshenerDealRecipes.pricing(_dealRecipe, qty);
    }
    if (_dealRecipe && _dealRecipe.key === 'BOGO') {
      window.ZUGAirFreshenerDealRecipes.validateQuantity(_dealRecipe, qty);
    }
    if (!_productContractRow || !window.ZUGAirFreshenerProductContract) return null;
    return window.ZUGAirFreshenerProductContract.basePrice(_productContractRow, qty);
  }

  var _state = {
    quantity: 50,
    fragrance: 'new_car',
    selectedFragrances: ['new_car'],
    shape: 'die_cut',
    printStyle: 'mirrored',
    activeSide: 'front',
    showPricingList: false,
    previewUrl: null,
    artworkUrl: null,
    detectedBorderColor: null,
    detectedBodyTopY800: null,
    _dcfLoading: false,
    _refreshQueued: false,
    _refreshDebounce: null,
    front: {
      file: null,
      fileName: '',
      imageUrl: null,
      originalDataUrl: null
    },
    back: {
      file: null,
      fileName: '',
      imageUrl: null,
      detectedBorderColor: null
    },
    dieCut: {
      removeBg: true,
      cropPreset: 'full',
      contourReady: false,
      cutline_svg_path: null,
      bbox_x_px: 0,
      bbox_y_px: 0,
      bbox_width_px: 0,
      bbox_height_px: 0,
      dcfUploadId: null,
      dcfOriginalUrl: null,
      processedArtworkUrl: null,
      dcfCutlinePath: null,
      dcfPhysicalW: null,
      dcfPhysicalH: null
    },
    currentPanel: 'shape',
    borderSize: 0.16,
    cornerRadius: 0.25,
    approved: false
  };

  function _fragranceLabel(key) {
    for (var i = 0; i < FRAGRANCES.length; i++) {
      if (FRAGRANCES[i].key === key) return FRAGRANCES[i].label;
    }
    return key;
  }

  function _syncFragranceState() {
    if (!_state.selectedFragrances || _state.selectedFragrances.length === 0) {
      _state.selectedFragrances = [_state.fragrance || 'new_car'];
    }
    _state.fragrance = _state.selectedFragrances[0];
  }

  function _validateDealState() {
    if (!_dealRecipe) return true;
    if (_dealRecipe.key === 'BOGO') {
      try {
        window.ZUGAirFreshenerDealRecipes.validateQuantity(_dealRecipe, _state.quantity);
        return _state.selectedFragrances.length > 0 &&
          ['mirrored', 'double'].indexOf(_state.printStyle) !== -1;
      } catch (error) {
        console.error('[ZUG-AF-BOGO] invalid offer state', error);
        return false;
      }
    }
    try {
      window.ZUGAirFreshenerDealRecipes.quote(_dealRecipe, {
        quantity: _state.quantity,
        fragranceCount: _state.selectedFragrances.length,
        printStyle: _state.printStyle
      });
      return true;
    } catch (error) {
      console.error('[ZUG-AF-DEAL] invalid deal state', error);
      return false;
    }
  }

  function _getAfSurcharges() {
    if (_sampleOffer) {
      return {
        fragranceUpchargeCents: 0,
        doubleImageFeeCents: 0,
        totalSurchargeCents: 0
      };
    }
    if (_dealRecipe && _dealRecipe.key === '50FOR99') {
      var dealQuote = window.ZUGAirFreshenerDealRecipes.quote(_dealRecipe, {
        quantity: _state.quantity,
        fragranceCount: _state.selectedFragrances.length,
        printStyle: _state.printStyle
      });
      return {
        fragranceUpchargeCents: 0,
        doubleImageFeeCents: dealQuote.doubleImageCents,
        totalSurchargeCents: dealQuote.doubleImageCents
      };
    }
    var extraFragrances = Math.max(0, _state.selectedFragrances.length - 1);
    var fragranceUpchargeCents = extraFragrances * AF_FRAGRANCE_UPCHARGE_CENTS;
    var doubleImageFeeCents = _state.printStyle === 'double' ? AF_DOUBLE_IMAGE_FEE_CENTS : 0;
    return {
      fragranceUpchargeCents: fragranceUpchargeCents,
      doubleImageFeeCents: doubleImageFeeCents,
      totalSurchargeCents: fragranceUpchargeCents + doubleImageFeeCents
    };
  }

  function _fragranceSummaryText() {
    var sel = _state.selectedFragrances;
    if (!sel || sel.length === 0) return 'Choose your fragrance';
    if (sel.length === 1) return _fragranceLabel(sel[0]);
    if (sel.length === 2) return _fragranceLabel(sel[0]) + ' + 1 more';
    return _fragranceLabel(sel[0]) + ' + ' + (sel.length - 1) + ' more';
  }

  function _updateFragranceSummary() {
    var el = document.getElementById('af-fragrance-summary');
    if (el) el.textContent = _fragranceSummaryText();
  }

  var _modalTempSelection = [];

  function _openFragranceModal() {
    var modal = document.getElementById('af-fragrance-modal');
    if (!modal) return;
    _modalTempSelection = _state.selectedFragrances.slice();
    _renderFragranceModalGrid();
    _updateFragranceModalSummary();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function _closeFragranceModal() {
    var modal = document.getElementById('af-fragrance-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function _applyFragranceSelection() {
    if (_modalTempSelection.length === 0) return;
    _state.selectedFragrances = _modalTempSelection.slice();
    _syncFragranceState();
    _updateFragranceSummary();
    _updatePriceDisplay();
    if (_state.showPricingList) _updatePricingList();
    _closeFragranceModal();
  }

  function _renderFragranceModalGrid() {
    var grid = document.getElementById('af-fragrance-modal-grid');
    if (!grid) return;
    grid.innerHTML = '';
    FRAGRANCES.forEach(function (f) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'af-fragrance-modal__tile';
      tile.setAttribute('data-fragrance', f.key);
      if (f.sold_out) {
        tile.classList.add('af-fragrance-modal__tile--sold-out');
        tile.disabled = true;
      }
      if (_modalTempSelection.indexOf(f.key) !== -1) {
        tile.classList.add('af-fragrance-modal__tile--selected');
      }
      if (f.image) {
        var img = document.createElement('img');
        img.src = f.image;
        img.alt = f.label;
        img.width = 60;
        img.height = 60;
        img.loading = 'lazy';
        tile.appendChild(img);
      }
      var lbl = document.createElement('span');
      lbl.className = 'af-fragrance-modal__tile-label';
      lbl.textContent = f.label;
      tile.appendChild(lbl);
      tile.addEventListener('click', function () {
        var idx = _modalTempSelection.indexOf(f.key);
        if (_dealRecipe && _dealRecipe.key !== 'BOGO') {
          if (idx === -1) {
            _modalTempSelection = [f.key];
            grid.querySelectorAll('.af-fragrance-modal__tile').forEach(function (candidate) {
              candidate.classList.toggle('af-fragrance-modal__tile--selected', candidate === tile);
            });
          }
          _updateFragranceModalSummary();
          return;
        }
        if (idx !== -1) {
          if (_modalTempSelection.length > 1) {
            _modalTempSelection.splice(idx, 1);
            tile.classList.remove('af-fragrance-modal__tile--selected');
          }
        } else {
          _modalTempSelection.push(f.key);
          tile.classList.add('af-fragrance-modal__tile--selected');
        }
        _updateFragranceModalSummary();
      });
      grid.appendChild(tile);
    });
  }

  function _updateFragranceModalSummary() {
    var countEl = document.getElementById('af-fragrance-modal-count');
    var upchargeEl = document.getElementById('af-fragrance-modal-upcharge');
    var applyBtn = document.getElementById('af-fragrance-modal-apply');
    var count = _modalTempSelection.length;
    var fixedDeal = _dealRecipe && _dealRecipe.key !== 'BOGO';
    if (countEl) countEl.textContent = fixedDeal ? count + ' of 1 selected' : count + ' selected';
    var extra = Math.max(0, count - 1);
    if (upchargeEl) {
      upchargeEl.textContent = fixedDeal
        ? 'One fragrance included'
        : (extra > 0 ? '+$' + (extra * 3) + '.00 fragrance fee' : 'Included in base price');
    }
    if (applyBtn) applyBtn.disabled = count === 0;
  }

  function _shapeLabel(key) {
    var s = SHAPES[key];
    return s ? s.label : key;
  }

  function _resetState() {
    _state.front = { file: null, fileName: '', imageUrl: null, originalDataUrl: null };
    _state.back = { file: null, fileName: '', imageUrl: null, mirroredDataUrl: null };
    _state._dualFrontFile = null;
    _state._dualBackFile = null;
    _state._backImgDims = null;
    _state.backBgColor = null;
    if (_state._backEditor) {
      try { _state._backEditor.canvas.dispose(); } catch (e) {}
      _state._backEditor = null;
    }
    _state._backEditorReady = false;
    if (_state._frontEditor) {
      try { _state._frontEditor.canvas.dispose(); } catch (e) {}
      _state._frontEditor = null;
    }
    _state._frontEditorReady = false;
    _state._frontBgShape = null;
    _state._presetBodyFill = null;
    _state._presetBackBodyFill = null;
    _state.frontBgColor = null;
    _state.previewUrl = null;
    _state.artworkUrl = null;
    _state.detectedBorderColor = null;
    _state.detectedBodyTopY800 = null;
    _state.back.detectedBorderColor = null;
    _positionHangingOverlays(false);
    _layoutArtFrame();
    if (_hangResizeObs) { _hangResizeObs.disconnect(); _hangResizeObs = null; }
    _state._dcfLoading = false;
    _state._refreshQueued = false;
    if (_state._refreshDebounce) { clearTimeout(_state._refreshDebounce); _state._refreshDebounce = null; }
    _state.dieCut = {
      removeBg: true, cropPreset: 'full', contourReady: false,
      cutline_svg_path: null, bbox_x_px: 0, bbox_y_px: 0, bbox_width_px: 0, bbox_height_px: 0,
      source_width_px: null, source_height_px: null,
      dcfUploadId: null, dcfOriginalUrl: null, processedArtworkUrl: null,
      dcfCutlinePath: null, dcfPhysicalW: null, dcfPhysicalH: null
    };
    _state.activeSide = 'front';
    _state.currentPanel = 'shape';
    _state.borderSize = 0.16;
    _state.cornerRadius = 0.25;
    _state.approved = false;

    var borderBtns = document.querySelectorAll('#zug-af-border-presets .zug-builder__preset');
    borderBtns.forEach(function (b) {
      b.classList.toggle('zug-builder__preset--active', parseFloat(b.getAttribute('data-border')) === 0.16);
    });

    var previewImg = document.getElementById('zug-af-modal-preview-img');
    if (previewImg) { previewImg.src = ''; previewImg.style.display = 'none'; }
    var cutlineSvg = document.getElementById('zug-af-cutline-svg');
    if (cutlineSvg) cutlineSvg.style.display = 'none';
    var cutlineFillSvg = document.getElementById('zug-af-cutline-fill-svg');
    if (cutlineFillSvg) cutlineFillSvg.style.display = 'none';
    var legendBar = document.getElementById('zug-af-cutline-legend-bar');
    if (legendBar) legendBar.style.display = 'none';
  }

  function _updatePriceDisplay() {
    var pricing = getPricing(_state.quantity);
    if (!pricing) return;
    var surcharges = _getAfSurcharges();
    var grandTotal = pricing.total + surcharges.totalSurchargeCents / 100;

    var totalEl = document.getElementById('af-price-total');
    var unitEl = document.getElementById('af-price-unit');
    var qtyEl = document.getElementById('af-price-qty');
    if (totalEl) totalEl.textContent = '$' + grandTotal.toFixed(2);
    if (unitEl) unitEl.textContent = '$' + pricing.unitPrice.toFixed(2);
    if (qtyEl) qtyEl.textContent = _state.quantity;
    if (_dealRecipe && _dealRecipe.key === 'BOGO') {
      var paidEl = document.getElementById('af-bogo-paid-quantity');
      var freeEl = document.getElementById('af-bogo-free-quantity');
      var totalQuantityEl = document.getElementById('af-bogo-total-quantity');
      if (paidEl) paidEl.textContent = String(_state.quantity);
      if (freeEl) freeEl.textContent = _state.quantity + ' free';
      if (totalQuantityEl) totalQuantityEl.textContent = (_state.quantity * 2) + ' total';
    }

    var fragRow = document.getElementById('af-price-fragrance-row');
    var fragLabel = document.getElementById('af-price-fragrance-label');
    var fragVal = document.getElementById('af-price-fragrance-val');
    if (fragRow) {
      if (surcharges.fragranceUpchargeCents > 0) {
        var extraCount = _state.selectedFragrances.length - 1;
        fragRow.style.display = '';
        if (fragLabel) fragLabel.textContent = 'Fragrance split (+' + extraCount + ')';
        if (fragVal) fragVal.textContent = '+$' + (surcharges.fragranceUpchargeCents / 100).toFixed(2);
      } else {
        fragRow.style.display = 'none';
      }
    }

    var dblRow = document.getElementById('af-price-double-row');
    var dblVal = document.getElementById('af-price-double-val');
    if (dblRow) {
      if (surcharges.doubleImageFeeCents > 0) {
        dblRow.style.display = '';
        if (dblVal) dblVal.textContent = '+$' + (surcharges.doubleImageFeeCents / 100).toFixed(2);
      } else {
        dblRow.style.display = 'none';
      }
    }
  }

  function _generateShapeCutlinePath() {
    if (_state.shape === 'die_cut') return null;
    var shape = SHAPES[_state.shape] || SHAPES.oval;
    var wIn = shape.width_in;
    var hIn = shape.height_in;
    var aspect = wIn / hIn;
    var vb = 800;
    var cx = vb / 2, cy = vb / 2;
    var normW, normH;
    if (aspect >= 1) {
      normW = 0.82;
      normH = 0.82 / aspect;
    } else {
      normH = 0.82;
      normW = 0.82 * aspect;
    }

    if (_state.shape === 'oval' || _state.shape === 'circle') {
      var rx = (normW / 2) * vb;
      var ry = (normH / 2) * vb;
      return {
        path: 'M ' + cx + ' ' + (cy - ry) +
              ' A ' + rx + ' ' + ry + ' 0 1 1 ' + cx + ' ' + (cy + ry) +
              ' A ' + rx + ' ' + ry + ' 0 1 1 ' + cx + ' ' + (cy - ry) + ' Z',
        bbox_x: cx - rx, bbox_y: cy - ry, bbox_w: rx * 2, bbox_h: ry * 2
      };
    }

    var w = normW * vb;
    var h = normH * vb;
    var x = (vb - w) / 2;
    var y = (vb - h) / 2;

    var crIn = shape.cornerRadius || 0;
    if (crIn > 0) {
      var crNorm = crIn / Math.max(wIn, hIn);
      var cr = crNorm * vb;
      cr = Math.min(cr, w / 2, h / 2);
      return {
        path: 'M ' + (x + cr) + ' ' + y +
              ' H ' + (x + w - cr) +
              ' A ' + cr + ' ' + cr + ' 0 0 1 ' + (x + w) + ' ' + (y + cr) +
              ' V ' + (y + h - cr) +
              ' A ' + cr + ' ' + cr + ' 0 0 1 ' + (x + w - cr) + ' ' + (y + h) +
              ' H ' + (x + cr) +
              ' A ' + cr + ' ' + cr + ' 0 0 1 ' + x + ' ' + (y + h - cr) +
              ' V ' + (y + cr) +
              ' A ' + cr + ' ' + cr + ' 0 0 1 ' + (x + cr) + ' ' + y + ' Z',
        bbox_x: x, bbox_y: y, bbox_w: w, bbox_h: h
      };
    }

    return {
      path: 'M ' + x + ' ' + y + ' H ' + (x + w) + ' V ' + (y + h) + ' H ' + x + ' Z',
      bbox_x: x, bbox_y: y, bbox_w: w, bbox_h: h
    };
  }

  function _updateCutlineOverlay() {
    var cutlineSvg = document.getElementById('zug-af-cutline-svg');
    var cutlineFillSvg = document.getElementById('zug-af-cutline-fill-svg');
    var legendBar = document.getElementById('zug-af-cutline-legend-bar');

    if (cutlineSvg) cutlineSvg.style.display = 'none';
    if (cutlineFillSvg) cutlineFillSvg.style.display = 'none';
    if (legendBar) legendBar.style.display = 'none';
  }

  function _isColorDark(color) {
    if (!color) return false;
    var c = color.replace(/\s/g, '').toLowerCase();
    var r = 0, g = 0, b = 0;
    if (c.indexOf('#') === 0) {
      var hex = c.slice(1);
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else if (c.indexOf('rgb') === 0) {
      var parts = c.match(/\d+/g);
      if (parts && parts.length >= 3) { r = +parts[0]; g = +parts[1]; b = +parts[2]; }
    } else {
      return false;
    }
    return (r * 0.299 + g * 0.587 + b * 0.114) < 128;
  }

  function _computeFittedSize() {
    var previewImg = document.getElementById('zug-af-modal-preview-img');
    if (_state.dieCut.contourReady) {
      var dw = _state.dieCut.dcfPhysicalW;
      var dh = _state.dieCut.dcfPhysicalH;
      if (dw && dh) return { w: dw, h: dh };
    }
    if (_state.shape !== 'die_cut') {
      var shape = SHAPES[_state.shape] || SHAPES.oval;
      return { w: shape.width_in, h: shape.height_in };
    }
    if (previewImg && previewImg.naturalWidth && previewImg.naturalHeight) {
      var natW = previewImg.naturalWidth;
      var natH = previewImg.naturalHeight;
      var ratio = natW / natH;
      var fitW = AF_MAX_FINISHED_W_IN;
      var fitH = fitW / ratio;
      if (fitH > AF_MAX_FINISHED_H_IN) {
        fitH = AF_MAX_FINISHED_H_IN;
        fitW = fitH * ratio;
      }
      return { w: Math.round(fitW * 100) / 100, h: Math.round(fitH * 100) / 100 };
    }
    var shape = SHAPES[_state.shape] || SHAPES.oval;
    return { w: shape.width_in, h: shape.height_in };
  }

  function _updateDimensionBadges() {
    var badgeW = document.getElementById('zug-af-badge-width');
    var badgeH = document.getElementById('zug-af-badge-height');
    var fitted = _computeFittedSize();
    if (badgeW) badgeW.textContent = fitted.w.toFixed(2) + '"';
    if (badgeH) badgeH.textContent = fitted.h.toFixed(2) + '"';
  }

  function _showPreviewImage(imageUrl) {
    var previewImg = document.getElementById('zug-af-modal-preview-img');
    if (!previewImg) return;
    previewImg.onload = function () {
      _updateDimensionBadges();
      _sampleBorderColor();
      _extractColorPalette();
      _drawHangingOverlay();
    };
    if (imageUrl && imageUrl.indexOf('data:') !== 0) {
      previewImg.crossOrigin = 'anonymous';
    } else {
      previewImg.removeAttribute('crossorigin');
    }
    previewImg.src = imageUrl;
    previewImg.style.display = 'block';
    _updateCutlineOverlay();
    if (previewImg.complete && previewImg.naturalWidth) {
      _updateDimensionBadges();
      _sampleBorderColor();
      _extractColorPalette();
    }
  }

  function _ensureColorToolsLoaded(cb) {
    if (window.ZUGModalColorTools) { cb(); return; }
    var modal = document.getElementById('zug-af-modal');
    var url = modal ? modal.getAttribute('data-color-tools-url') : '';
    if (!url) return;
    var script = document.createElement('script');
    script.src = url;
    script.onload = cb;
    document.head.appendChild(script);
  }

  function _extractColorPalette() {
    var labelEl = document.getElementById('zug-af-suggested-fill-label');
    var helperEl = document.getElementById('zug-af-suggested-fill-helper');
    var colorsEl = document.getElementById('zug-af-suggested-fill-colors');
    if (!colorsEl) return;

    var srcUrl;
    if (_state.activeSide === 'back') {
      srcUrl = _state.back.imageUrl || _state.back.mirroredDataUrl;
    } else {
      srcUrl = _state.front.originalDataUrl || _state.front.imageUrl;
    }
    if (!srcUrl) return;

    _ensureColorToolsLoaded(function () {
      var tempImg = new Image();
      tempImg.crossOrigin = 'anonymous';
      tempImg.onload = function () {
        _doExtractColorPalette(tempImg, labelEl, helperEl, colorsEl);
      };
      tempImg.src = srcUrl;
    });
  }

  function _doExtractColorPalette(imgEl, labelEl, helperEl, colorsEl) {
    if (!window.ZUGModalColorTools || !window.ZUGModalColorTools.extractPalette) return;
    try {
      var palette = window.ZUGModalColorTools.extractPalette(imgEl);
      var colors = window.ZUGModalColorTools.suggestFillColors(palette, { sortByVibrance: true });
      if (!colors || colors.length === 0) {
        if (labelEl) labelEl.style.display = 'none';
        if (helperEl) helperEl.style.display = 'none';
        colorsEl.style.display = 'none';
        return;
      }
      _syncHumpColor();
      colorsEl.innerHTML = '';
      colors.forEach(function (hex) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zug-color-chip';
        btn.style.background = hex;
        btn.setAttribute('data-color', hex);
        btn.setAttribute('title', hex);
        btn.addEventListener('click', function () {
          if (_state.activeSide === 'back' && _state.printStyle === 'double') {
            _state.backBgColor = hex;
            if (_state._backEditor) _setBackBgShape(hex);
            return;
          }
          var fillColorInput = document.getElementById('zug-af-fill-color');
          var solidRadio = document.querySelector('input[name="zug-af-fill"][value="solid"]');
          if (solidRadio) solidRadio.checked = true;
          if (fillColorInput) { fillColorInput.value = hex; fillColorInput.style.display = ''; }
          _state.fillColor = hex;
          _syncHumpColor();
          if (_state.shape !== 'die_cut' && _state._frontEditor) {
            _state.frontBgColor = hex;
            _setFrontBgShape(hex);
            return;
          }
          _refreshPreview();
        });
        colorsEl.appendChild(btn);
      });
      if (labelEl) labelEl.style.display = '';
      if (helperEl) helperEl.style.display = '';
      colorsEl.style.display = '';
    } catch (e) {
      console.warn('[ZUG-AF] color extraction failed:', e);
      if (labelEl) labelEl.style.display = 'none';
      if (helperEl) helperEl.style.display = 'none';
      colorsEl.style.display = 'none';
    }
  }

  function _readFileAsDataURL(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = function () { reject(reader.error); };
      reader.readAsDataURL(file);
    });
  }

  function _loadImageFromUrl(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Failed to load image')); };
      img.src = url;
    });
  }

  function _refreshCartAndOpenDrawer() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart refresh failed.');
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show();
          }
        }, 300);
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  async function _uploadFileForCart(file, filename) {
    try {
      var formData = new FormData();
      formData.append('file', file, filename || 'artwork.png');
      formData.append('outline_thickness_px', '0');
      formData.append('remove_bg', 'false');
      formData.append('fill_mode', 'original');

      var resp = await fetch(DCF_BASE + '/preview', {
        method: 'POST',
        body: formData
      });
      if (!resp.ok) throw new Error('Upload failed: ' + resp.status);
      var data = await resp.json();
      console.log('[ZUG-AF] uploaded artwork for cart:', data.preview_id);
      return {
        upload_id: data.preview_id,
        preview_url: data.preview_url || data.original_url,
        original_url: data.original_url
      };
    } catch (err) {
      console.error('[ZUG-AF] artwork upload for cart failed:', err);
      return null;
    }
  }

  function _packagingLabel() {
    if (!_productContractRow) return '';
    if (_productContractRow.packaging === 'header_card') return 'Header Card';
    if (_productContractRow.packaging === 'backer_card') return 'Backer Card';
    return '';
  }

  function _applyPackagingStatus(properties, status) {
    var label = _packagingLabel();
    if (!label) return;
    properties.Packaging = label;
    properties['Packaging Artwork Status'] = status;
  }

  function _validatePackagingArtworkSelection() {
    if (!_productContractRow || _productContractRow.packaging === 'none') return true;
    if (_productContractRow.packaging === 'header_card' && !_packagingArtwork.header) {
      alert('Please choose the Header Card artwork file before continuing.');
      return false;
    }
    if (_productContractRow.packaging === 'backer_card' &&
        (!_packagingArtwork.backerFront || !_packagingArtwork.backerBack)) {
      alert('Please choose both the front and back Backer Card artwork files before continuing.');
      return false;
    }
    return true;
  }

  async function _attachApprovedPackagingArtwork(properties) {
    _applyPackagingStatus(properties, 'Approved');
    if (!_productContractRow || _productContractRow.packaging === 'none') return;
    if (!_validatePackagingArtworkSelection()) {
      throw new Error('Required packaging artwork is missing.');
    }
    if (_productContractRow.packaging === 'header_card') {
      var headerUpload = await _uploadFileForCart(_packagingArtwork.header, _packagingArtwork.header.name);
      if (!headerUpload || !headerUpload.original_url) throw new Error('Header Card artwork upload failed.');
      properties['Header Card File'] = _packagingArtwork.header.name;
      properties._af_header_card_original_url = headerUpload.original_url;
      if (headerUpload.preview_url) properties._af_header_card_preview_url = headerUpload.preview_url;
      if (headerUpload.upload_id) properties._af_header_card_upload_id = headerUpload.upload_id;
      return;
    }
    var frontUpload = await _uploadFileForCart(_packagingArtwork.backerFront, _packagingArtwork.backerFront.name);
    var backUpload = await _uploadFileForCart(_packagingArtwork.backerBack, _packagingArtwork.backerBack.name);
    if (!frontUpload || !frontUpload.original_url || !backUpload || !backUpload.original_url) {
      throw new Error('Backer Card artwork upload failed.');
    }
    properties['Backer Card Front File'] = _packagingArtwork.backerFront.name;
    properties['Backer Card Back File'] = _packagingArtwork.backerBack.name;
    properties._af_backer_card_front_original_url = frontUpload.original_url;
    properties._af_backer_card_back_original_url = backUpload.original_url;
    if (frontUpload.preview_url) properties._af_backer_card_front_preview_url = frontUpload.preview_url;
    if (backUpload.preview_url) properties._af_backer_card_back_preview_url = backUpload.preview_url;
    if (frontUpload.upload_id) properties._af_backer_card_front_upload_id = frontUpload.upload_id;
    if (backUpload.upload_id) properties._af_backer_card_back_upload_id = backUpload.upload_id;
  }

  function _initPackagingArtworkInputs() {
    [
      ['af-header-card-file', 'header', 'af-header-card-file-name'],
      ['af-backer-card-front-file', 'backerFront', 'af-backer-card-front-file-name'],
      ['af-backer-card-back-file', 'backerBack', 'af-backer-card-back-file-name']
    ].forEach(function (entry) {
      var input = document.getElementById(entry[0]);
      var name = document.getElementById(entry[2]);
      if (!input) return;
      input.addEventListener('change', function () {
        _packagingArtwork[entry[1]] = input.files && input.files[0] ? input.files[0] : null;
        if (name) name.textContent = _packagingArtwork[entry[1]]
          ? _packagingArtwork[entry[1]].name
          : 'Choose artwork file';
      });
    });
  }

  async function _handleFileUpload(side, file) {
    if (!file) return;

    var validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml'];
    var ext = file.name.split('.').pop().toLowerCase();
    var isValid = validTypes.indexOf(file.type) !== -1 || ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'pdf', 'ai', 'psd', 'tiff'].indexOf(ext) !== -1;

    if (!isValid) {
      alert('Please upload a valid image file (PNG, JPG, SVG, etc.)');
      return;
    }

    var isRasterImage = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp'].indexOf(file.type) !== -1;

    if (!isRasterImage) {
      _state[side].file = file;
      _state[side].fileName = file.name;
      _state[side].imageUrl = null;
      _showUploadComplete(side, file.name);
      _updateGating();
      return;
    }

    try {
      var dataUrl = await _readFileAsDataURL(file);
      _state[side].file = file;
      _state[side].fileName = file.name;
      _state[side].imageUrl = dataUrl;
      if (side === 'front') _state.front.originalDataUrl = dataUrl;

      if (side === 'front') {
        _state.dieCut.contourReady = false;
        _state.dieCut.dcfUploadId = null;
        _state.dieCut.dcfOriginalUrl = null;
        _state.dieCut.processedArtworkUrl = null;
        _state.dieCut.dcfCutlinePath = null;
        _state.dieCut.dcfPhysicalW = null;
        _state.dieCut.dcfPhysicalH = null;
        _state.dieCut.cutline_svg_path = null;

        if (_state.shape !== 'die_cut') {
          await _renderSimpleShapePreview();
          var simpleUrl = _state.previewUrl || dataUrl;
          _showPreviewImage(simpleUrl);
          _state.back.mirroredDataUrl = null;
          _updateStatusBar();
          _updateGating();
          _initFrontPlacementEditor();
        } else {
          var dcfResult = await _callDCFPreview(file);
          if (!dcfResult) {
            _showPreviewImage(dataUrl);
            _state.back.mirroredDataUrl = null;
            if (_state.printStyle === 'mirrored') {
              _state.back.file = _state.front.file;
              _state.back.fileName = _state.front.fileName;
              _renderMirroredBack();
            }
            _updateStatusBar();
            _updateGating();
            return;
          }

          _applyDCFResponse(dcfResult);

          var displayUrl = _state.previewUrl || dataUrl;
          _state.front.imageUrl = displayUrl;
          _showPreviewImage(displayUrl);

          _state.back.mirroredDataUrl = null;
          if (_state.printStyle === 'mirrored') {
            _state.back.file = _state.front.file;
            _state.back.fileName = _state.front.fileName;
            _renderMirroredBack();
          }
          if (_state._backEditor) {
            try { _state._backEditor.canvas.dispose(); } catch (e) {}
            _state._backEditor = null;
            _state._backEditorReady = false;
          }
        }
      } else if (side === 'back') {
        var uploadZoneB = document.getElementById('zug-af-upload-zone-back');
        if (uploadZoneB) uploadZoneB.style.display = 'none';
        var toolbarElB = document.getElementById('zug-af-back-toolbar');
        if (toolbarElB) toolbarElB.style.display = '';
        var filenameElB = document.getElementById('zug-af-filename-back');
        if (filenameElB) filenameElB.textContent = file.name;
        _state.back.imageUrl = dataUrl;
        _state._backImgDims = null;
        var bImg = new Image();
        bImg.src = dataUrl;
        bImg.onload = function () {
          _state._backImgDims = { w: bImg.naturalWidth, h: bImg.naturalHeight };
        };

        if (_state._backEditor) {
          try { _state._backEditor.canvas.dispose(); } catch (e) {}
          _state._backEditor = null;
          _state._backEditorReady = false;
        }
        if (_state.printStyle === 'double' && _state.currentPanel === 'back') {
          _showPreviewImage(dataUrl);
          _initBackPlacementEditor();
        } else if (_state.currentPanel === 'back') {
          _showPreviewImage(dataUrl);
        }
      }

      _updateStatusBar();
      _updateGating();
    } catch (err) {
      console.error('[ZUG-AF] file upload error:', err);
      var msg = 'Error loading file.';
      if (err && err.message) msg += ' (' + err.message + ')';
      msg += ' Please try again.';
      alert(msg);
    }
  }

  function _showUploadComplete(side, name) {
    var uploadZone = document.getElementById('zug-af-upload-zone-' + side);
    if (uploadZone) {
      uploadZone.innerHTML = '<div style="padding:20px;text-align:center;">' +
        '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
        '<p style="margin:8px 0 2px;font-weight:600;color:#1f2937;">' + name + '</p>' +
        '<p style="margin:0;font-size:0.75rem;color:#6b7280;">Uploaded (non-raster file — will be processed by our team)</p>' +
        '</div>';
    }
  }

  function _updateGating() {
    var submitBtn = document.getElementById('zug-af-confirm-submit');
    var approveCheck = document.getElementById('zug-af-approve-check');

    if (submitBtn) {
      var canSubmit = approveCheck && approveCheck.checked;
      if (canSubmit && _state.printStyle === 'double' && !_state.back.file && !_state.back.imageUrl) {
        canSubmit = false;
      }
      submitBtn.classList.toggle('is-disabled', !canSubmit);

      var acceptLabel = document.getElementById('zug-af-accept-label');
      var activeProofPill = document.querySelector('#zug-af-proof-pills .zug-builder__proof-pill--active');
      var commentMode = activeProofPill && activeProofPill.dataset.proof === 'comment';
      if (acceptLabel && commentMode) {
        acceptLabel.textContent = 'I understand a new proof is required before production.';
      } else if (acceptLabel && _state.printStyle === 'double' && !_state.back.file && !_state.back.imageUrl) {
        acceptLabel.textContent = 'I have reviewed my artwork (back artwork required)';
      } else if (acceptLabel) {
        acceptLabel.textContent = 'I have reviewed my artwork';
      }
    }
  }

  function _showApprovalWarning() {
    _switchPanel('review');

    var toast = document.getElementById('zug-af-approval-toast');
    if (toast) {
      toast.classList.add('is-visible');
      clearTimeout(_state._toastTimer);
      _state._toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
    }

    var approveCheck = document.getElementById('zug-af-approve-check');
    if (!approveCheck) return;
    var cbLabel = approveCheck.closest('label') || approveCheck.parentElement;
    var approvalCard = approveCheck.closest('.zug-builder__card');

    if (cbLabel) {
      cbLabel.classList.remove('zug-attention');
      void cbLabel.offsetWidth;
      cbLabel.classList.add('zug-attention');
      cbLabel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { cbLabel.classList.remove('zug-attention'); }, 1200);
    }
    if (approvalCard && approvalCard !== cbLabel) {
      approvalCard.classList.remove('zug-attention');
      void approvalCard.offsetWidth;
      approvalCard.classList.add('zug-attention');
      setTimeout(function () { approvalCard.classList.remove('zug-attention'); }, 1200);
    }
  }

  function _computeDPI(side) {
    side = side || _state.activeSide || (_state.currentPanel === 'back' ? 'back' : 'front');
    var fitted = _computeFittedSize();
    if (side === 'front') {
      if (_state._frontEditor && _state._frontEditorReady && _state._frontEditor.art) {
        var art = _state._frontEditor.art;
        var artScale = art.scaleX || 1;
        var renderedW = art.width * artScale;
        var renderedH = art.height * artScale;
        var editorSize = _state._frontEditor.canvas.getWidth();
        var printMaxDim = Math.max(fitted.w, fitted.h);
        var scaledW = (renderedW / editorSize) * printMaxDim;
        var scaledH = (renderedH / editorSize) * printMaxDim;
        if (scaledW > 0 && scaledH > 0) {
          var dpiW = art.width / scaledW;
          var dpiH = art.height / scaledH;
          return Math.round(Math.min(dpiW, dpiH));
        }
      }
      var srcW = _state.dieCut.source_width_px || _state.dieCut.bbox_width_px;
      var srcH = _state.dieCut.source_height_px || _state.dieCut.bbox_height_px;
      if (srcW && srcH && fitted.w > 0 && fitted.h > 0) {
        var dpiW = srcW / fitted.w;
        var dpiH = srcH / fitted.h;
        return Math.round(Math.min(dpiW, dpiH));
      }
    }
    if (side === 'back') {
      if (_state._backEditor && _state._backEditorReady && _state._backEditor.art) {
        var art = _state._backEditor.art;
        var artScale = art.scaleX || 1;
        var renderedW = art.width * artScale;
        var renderedH = art.height * artScale;
        var editorSize = _state._backEditor.canvas.getWidth();
        var printMaxDim = Math.max(fitted.w, fitted.h);
        var scaledW = (renderedW / editorSize) * printMaxDim;
        var scaledH = (renderedH / editorSize) * printMaxDim;
        var origW = art.width;
        var origH = art.height;
        var dpiW = scaledW > 0 ? Math.round(origW / scaledW) : 0;
        var dpiH = scaledH > 0 ? Math.round(origH / scaledH) : 0;
        return Math.min(dpiW, dpiH);
      }
      var backSrc = _state.back.mirroredDataUrl || _state.back.imageUrl;
      if (backSrc && _state._backImgDims) {
        var maxDimB = Math.max(fitted.w, fitted.h);
        var maxPxB = Math.max(_state._backImgDims.w, _state._backImgDims.h);
        return maxDimB > 0 ? Math.round(maxPxB / maxDimB) : 0;
      }
    }
    var previewImg = document.getElementById('zug-af-modal-preview-img');
    if (previewImg && previewImg.naturalWidth) {
      var maxDim = Math.max(fitted.w, fitted.h);
      var maxPx = Math.max(previewImg.naturalWidth, previewImg.naturalHeight);
      return maxDim > 0 ? Math.round(maxPx / maxDim) : 0;
    }
    return 0;
  }

  function _updateReviewPanel() {
    var sizePrimary = document.getElementById('zug-af-size-primary');
    if (sizePrimary) {
      var fitted = _computeFittedSize();
      sizePrimary.innerHTML = fitted.w.toFixed(2) + '" &times; ' + fitted.h.toFixed(2) + '"';
    }

    var reviewToggle = document.getElementById('zug-af-review-side-toggle');
    var reviewPreview = document.getElementById('zug-af-review-preview');
    var reviewImg = document.getElementById('zug-af-review-preview-img');
    var reviewChipFront = document.getElementById('zug-af-review-chip-front');
    var reviewChipBack = document.getElementById('zug-af-review-chip-back');

    var hasDualSides = _hasBackPreview();
    if (reviewToggle) reviewToggle.style.display = hasDualSides ? 'flex' : 'none';
    if (reviewChipFront) reviewChipFront.classList.toggle('is-active', _state.activeSide === 'front');
    if (reviewChipBack) reviewChipBack.classList.toggle('is-active', _state.activeSide === 'back');

    var activeSrc = null;
    if (_state.activeSide === 'back') {
      activeSrc = _state.back.renderedSnapshot || _state.back.mirroredDataUrl || _state.back.imageUrl
        || (_state.printStyle === 'mirrored' ? (_state.front.renderedSnapshot || _state.previewUrl || _state.front.imageUrl) : null);
    } else {
      activeSrc = _state.previewUrl || _state.front.renderedSnapshot || _state.front.imageUrl;
    }
    if (reviewPreview && reviewImg) {
      if (activeSrc) {
        reviewImg.src = activeSrc;
        reviewPreview.style.display = 'flex';
      } else {
        reviewPreview.style.display = 'none';
      }
    }

    var side = _state.activeSide || 'front';
    var reviewFilenameEl = document.getElementById('zug-af-review-filename');
    if (reviewFilenameEl) {
      var sideFileName = side === 'back' ? (_state.back.fileName || '--') : (_state.front.fileName || '--');
      reviewFilenameEl.textContent = sideFileName;
    }
    var dpiBadgePanel = document.getElementById('zug-af-dpi-badge-panel');
    var sideState = _state[side];
    if (dpiBadgePanel && sideState && sideState.imageUrl) {
      var dpi = _computeDPI(side);
      if (dpi > 0) _showDpiBadge(dpiBadgePanel, dpi);
    }
  }


  function _syncBackPanelVisibility() {
    var show = _state.printStyle === 'double';
    var railBtn = document.querySelector('#zug-af-rail .zug-rail-btn[data-panel="back"]');
    var panel = document.getElementById('zug-af-panel-back');
    if (railBtn) {
      railBtn.classList.add('is-hidden');
    }
    if (panel) {
      if (show) { panel.classList.remove('is-hidden'); }
      else { panel.classList.add('is-hidden'); panel.classList.remove('is-visible'); panel.style.display = 'none'; }
    }
    if (!show && _state.currentPanel === 'back') {
      _switchPanel('background');
    }
  }

  function _wireFillRadios() {
    var fillRadios = document.querySelectorAll('input[name="zug-af-fill"]');
    var fillColorInput = document.getElementById('zug-af-fill-color');
    fillRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (_state.activeSide === 'back' && _state.printStyle === 'double') {
          if (radio.value === 'solid') {
            var color = fillColorInput ? fillColorInput.value : '#ffffff';
            _state.backBgColor = color;
            if (_state._backEditor) _setBackBgShape(color);
          } else {
            _state.backBgColor = null;
            if (_state._backEditor) _setBackBgShape(null);
          }
          return;
        }
        if (radio.value === 'solid') {
          if (fillColorInput) fillColorInput.style.display = '';
          var color = fillColorInput ? fillColorInput.value : '#ffffff';
          _state.fillColor = color;
          _syncHumpColor();
          if (_state.shape !== 'die_cut' && _state._frontEditor) {
            _state.frontBgColor = color;
            _setFrontBgShape(color);
            return;
          }
        } else {
          if (fillColorInput) fillColorInput.style.display = 'none';
          _state.fillColor = null;
          _syncHumpColor();
          if (_state.shape !== 'die_cut' && _state._frontEditor) {
            _state.frontBgColor = null;
            _setFrontBgShape(null);
            return;
          }
        }
        _refreshPreview();
      });
    });
    if (fillColorInput) {
      fillColorInput.addEventListener('input', function () {
        if (_state.activeSide === 'back' && _state.printStyle === 'double') {
          _state.backBgColor = fillColorInput.value;
          if (_state._backEditor) _setBackBgShape(fillColorInput.value);
          return;
        }
        _state.fillColor = fillColorInput.value;
        _syncHumpColor();
        if (_state.shape !== 'die_cut' && _state._frontEditor) {
          _state.frontBgColor = fillColorInput.value;
          _setFrontBgShape(fillColorInput.value);
        }
      });
      fillColorInput.addEventListener('change', function () {
        if (_state.activeSide === 'back' && _state.printStyle === 'double') {
          _state.backBgColor = fillColorInput.value;
          if (_state._backEditor) _setBackBgShape(fillColorInput.value);
          return;
        }
        _state.fillColor = fillColorInput.value;
        _syncHumpColor();
        if (_state.shape !== 'die_cut' && _state._frontEditor) {
          _state.frontBgColor = fillColorInput.value;
          _setFrontBgShape(fillColorInput.value);
          return;
        }
        _refreshPreview();
      });
    }
  }

  function _wireBorderPresets() {
    var presetBtns = document.querySelectorAll('#zug-af-border-presets .zug-builder__preset');
    presetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        presetBtns.forEach(function (b) { b.classList.remove('zug-builder__preset--active'); });
        btn.classList.add('zug-builder__preset--active');
        _state.borderSize = parseFloat(btn.getAttribute('data-border')) || 0.12;
        _refreshPreview();
      });
    });
  }

  function _wireShapeButtons() {
    var shapeBtns = document.querySelectorAll('#zug-af-shape-buttons-step2 .zug-modal__shape-btn');
    var titleLabel = document.getElementById('zug-af-shape-title-label');
    var headerLabel = document.getElementById('zug-af-shape-header-label');
    var LABELS = { die_cut: 'Custom Shape', oval: 'Oval', circle: 'Circle', square: 'Square', rectangle: 'Rectangle' };
    shapeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        shapeBtns.forEach(function (b) { b.classList.remove('zug-modal__shape-btn--active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('zug-modal__shape-btn--active');
        btn.setAttribute('aria-pressed', 'true');
        var shape = btn.getAttribute('data-shape');
        console.log('[ZUG-AF-SHAPE] builder shape btn clicked:', shape, '| prev:', _state.shape);
        _state.shape = shape;
        var label = LABELS[shape] || shape;
        if (titleLabel) titleLabel.textContent = label;
        if (headerLabel) headerLabel.textContent = label;
        _refreshPreview();
      });
    });
  }

  function _syncBuilderShapeButtons() {
    var shapeBtns = document.querySelectorAll('#zug-af-panel-shape .zug-modal__shape-btn');
    shapeBtns.forEach(function (btn) {
      var shape = btn.getAttribute('data-shape');
      if (shape === _state.shape) {
        btn.classList.add('zug-modal__shape-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('zug-modal__shape-btn--active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
    var LABELS = { die_cut: 'Custom Shape', oval: 'Oval', circle: 'Circle', square: 'Square', rectangle: 'Rectangle' };
    var titleLabel = document.getElementById('zug-af-shape-title-label');
    var headerLabel = document.getElementById('zug-af-shape-header-label');
    if (titleLabel) titleLabel.textContent = LABELS[_state.shape] || _state.shape;
    if (headerLabel) headerLabel.textContent = LABELS[_state.shape] || _state.shape;
  }

  function _wireDieCutTools() {
    var removeBgCheckbox = document.getElementById('zug-af-remove-bg');
    if (removeBgCheckbox) {
      removeBgCheckbox.addEventListener('change', function () {
        _state.dieCut.removeBg = removeBgCheckbox.checked;
        _refreshPreview();
      });
    }
  }

  var AF_PANEL_IDS = ['shape', 'cut', 'background', 'back', 'review'];
  var AF_PANEL_TITLES = {
    shape: 'Shape & Cut',
    cut: 'Cut Style',
    background: 'Background',
    back: 'Back Design',
    review: 'Review & Approve'
  };

  function _switchPanel(panelId) {
    if (AF_PANEL_IDS.indexOf(panelId) === -1) return;

    var target = document.getElementById('zug-af-panel-' + panelId);
    if (target && target.classList.contains('is-hidden')) return;
    console.log('[ZUG-AF-PANEL] _switchPanel:', panelId, '| from:', _state.currentPanel, '| activeSide:', _state.activeSide, '| shape:', _state.shape);

    var panels = document.querySelectorAll('#zug-af-step-builder .zug-panel');
    var railBtns = document.querySelectorAll('#zug-af-rail .zug-rail-btn');

    panels.forEach(function (p) { p.classList.remove('is-visible'); p.style.display = 'none'; });
    railBtns.forEach(function (b) { b.classList.remove('is-active'); });

    if (target) { target.classList.add('is-visible'); target.style.display = 'flex'; }
    var activeBtn = document.querySelector('#zug-af-rail .zug-rail-btn[data-panel="' + panelId + '"]');
    if (activeBtn) activeBtn.classList.add('is-active');

    var titleEl = document.getElementById('zug-af-modal-title');
    if (titleEl) titleEl.textContent = AF_PANEL_TITLES[panelId] || 'Review & Approve';

    var stepEl = document.getElementById('zug-af-step-builder');
    if (stepEl) {
      if (panelId === 'shape' || panelId === 'cut') {
        stepEl.classList.add('af-step--fill');
      } else {
        stepEl.classList.remove('af-step--fill');
      }
    }

    var disclaimer = document.getElementById('zug-af-disclaimer');
    if (disclaimer) {
      disclaimer.style.display = (panelId === 'review' || panelId === 'shape' || panelId === 'cut' || panelId === 'background') ? '' : 'none';
    }

    var backToolbar = document.getElementById('zug-af-back-toolbar');
    if (panelId === 'back') {
      if (backToolbar) backToolbar.style.display = 'none';
    }

    var prevPanel = _state.currentPanel;
    if (panelId === 'back' && prevPanel !== 'back') {
      _state._prevNonBackPanel = prevPanel;
    }
    _state.currentPanel = panelId;

    if (panelId === 'back') {
      _hideFrontEditor();
      _setupBackStep();
    } else if (panelId === 'review') {
      if (_state._frontEditorReady) {
        _captureFrontEditorSnapshot();
      }
      _hideFrontEditor();
      if (_state._backEditorReady) {
        _captureBackEditorSnapshot();
      }
      _hideBackEditor();
      _state.activeSide = 'front';
      var frontDisplay = _state.previewUrl || _state.front.imageUrl;
      if (frontDisplay) _showPreviewImage(frontDisplay);
      _updateReviewPanel();
    } else if (_state.activeSide === 'back') {
      if (_state._backEditorReady && _state.printStyle === 'double') {
        _extractColorPalette();
      }
    } else {
      if (_state._frontEditorReady && prevPanel !== 'shape') {
        _captureFrontEditorSnapshot();
      }
      if (_state._backEditorReady && prevPanel === 'back') {
        _captureBackEditorSnapshot();
      }
      _hideBackEditor();
      _state.activeSide = 'front';
      if (_state.shape !== 'die_cut' && _state._frontEditorReady) {
        _showFrontEditor();
      } else {
        _hideFrontEditor();
        var frontDisplay = _state.previewUrl || _state.front.imageUrl;
        if (frontDisplay) _showPreviewImage(frontDisplay);
      }
    }

    _syncSideToggle();
    _updateStatusBar();
    _updateGating();
  }

  (function _initAFPanelListeners() {
    document.addEventListener('click', function (e) {
      var railBtn = e.target.closest('#zug-af-rail .zug-rail-btn');
      if (railBtn && !railBtn.classList.contains('is-hidden')) {
        e.stopImmediatePropagation();
        var id = railBtn.getAttribute('data-panel');
        if (id) _switchPanel(id);
      }
    }, true);
  })();

  function _updateStatusBar() {
    var dpiBadge = document.getElementById('zug-af-dpi-badge');
    var filenameEl = document.getElementById('zug-af-modal-confirm-filename');
    var panel = _state.currentPanel;

    if (panel === 'review') {
      if (dpiBadge) { dpiBadge.className = 'zug-builder__dpi-badge zug-builder__dpi-badge--hidden'; }
      if (filenameEl) filenameEl.textContent = '';
      return;
    }

    var side = _state.activeSide || (panel === 'back' ? 'back' : 'front');
    var sideState = _state[side];

    if (sideState && sideState.fileName) {
      if (filenameEl) filenameEl.textContent = sideState.fileName;

      var dpi = _computeDPI();
      if (dpi > 0) {
        _showDpiBadge(dpiBadge, dpi);
      } else {
        if (dpiBadge) { dpiBadge.className = 'zug-builder__dpi-badge zug-builder__dpi-badge--hidden'; }
      }
    } else {
      if (dpiBadge) { dpiBadge.className = 'zug-builder__dpi-badge zug-builder__dpi-badge--hidden'; }
      if (filenameEl) filenameEl.textContent = '';
    }
  }

  function _showDpiBadge(el, dpi) {
    if (!el) return;
    var cls, label;
    if (dpi >= 300) { cls = 'great'; label = dpi + ' DPI \u2013 Great'; }
    else if (dpi >= 200) { cls = 'good'; label = dpi + ' DPI \u2013 Good'; }
    else if (dpi >= 150) { cls = 'fair'; label = dpi + ' DPI \u2013 Fair'; }
    else if (dpi >= 100) { cls = 'low'; label = dpi + ' DPI \u2013 Low'; }
    else { cls = 'verylow'; label = dpi + ' DPI \u2013 Very Low'; }
    el.className = 'zug-builder__dpi-badge zug-builder__dpi-badge--' + cls;
    el.textContent = label;
  }

  function _hasBackPreview() {
    if (_state.printStyle === 'mirrored') {
      if (_state.shape === 'die_cut') return !!_state.back.mirroredDataUrl;
      return !!(_state.front.renderedSnapshot || _state.previewUrl || _state.front.imageUrl);
    }
    return !!(_state.back.imageUrl || _state.back.file);
  }

  function _updateMirroredNotice() {
    var notice = document.getElementById('zug-af-mirrored-notice');
    if (!notice) {
      var stage = document.getElementById('zug-af-preview-stage');
      if (!stage) return;
      notice = document.createElement('div');
      notice.id = 'zug-af-mirrored-notice';
      notice.className = 'zug-af-mirrored-notice';
      notice.textContent = 'Back side is the same as the front';
      stage.appendChild(notice);
    }
    var show = _state.activeSide === 'back' && _state.printStyle === 'mirrored';
    notice.style.display = show ? '' : 'none';
  }

  function _getBody800Bounds() {
    if (_state.shape !== 'die_cut') {
      var shape = SHAPES[_state.shape] || SHAPES.oval;
      var aspect = shape.width_in / shape.height_in;
      var normH, normW;
      if (aspect >= 1) { normW = 0.82; normH = 0.82 / aspect; }
      else { normH = 0.82; normW = 0.82 * aspect; }
      var bodyH = normH * 800;
      var bodyW = normW * 800;
      return { y: (800 - bodyH) / 2, h: bodyH, x: (800 - bodyW) / 2, w: bodyW };
    }
    var cutPath = _state.dieCut.cutline_svg_path;
    if (cutPath) {
      return _getPathBBox(cutPath);
    }
    return { y: 72, h: 656, x: 72, w: 656 };
  }

  function _layoutArtFrame() {
    var stage = document.getElementById('zug-af-stage');
    if (!stage) return null;
    var stageW = stage.offsetWidth;
    var stageH = stage.offsetHeight;
    if (!stageW || !stageH) return null;
    var parentEl = stage.parentElement;
    if (parentEl && parentEl.clientHeight > 0 && parentEl.clientHeight < stageH) {
      stageH = parentEl.clientHeight;
    }

    var clearancePx = 0;
    var svg = document.getElementById('zug-af-hang-combined');
    var hasHanger = svg && svg.style.display !== 'none';
    if (hasHanger) {
      var fitted = _computeFittedSize();
      var physH = fitted.h;
      if (physH > 0) {
        var body800 = _getBody800Bounds();
        var bodyFracH = body800.h / 800;
        var k = AF_HANGER_STICKOUT_IN + AF_HANGER_MARGIN_IN;
        var cHeight = k * bodyFracH * stageH / (physH + k * bodyFracH);
        var wScale = stageW / 800;
        var cWidth = k * bodyFracH * 800 * wScale / physH;
        clearancePx = Math.round(Math.max(Math.min(cHeight, cWidth), 10));
      }
    }

    var availH = stageH - clearancePx;
    var frameSize = Math.floor(Math.min(stageW, availH));
    var frameTop = clearancePx + Math.floor((availH - frameSize) / 2);
    var frameLeft = Math.floor((stageW - frameSize) / 2);

    var ids = ['zug-af-preview-stack', 'zug-af-front-editor-wrap', 'zug-af-back-editor-wrap'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (!el) continue;
      el.style.top = frameTop + 'px';
      el.style.left = frameLeft + 'px';
      el.style.width = frameSize + 'px';
      el.style.height = frameSize + 'px';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
    }

    _state._artFrame = { top: frameTop, left: frameLeft, size: frameSize, clearancePx: clearancePx };
    return _state._artFrame;
  }

  function _positionHangingOverlays(visible) {
    var svg = document.getElementById('zug-af-hang-combined');
    if (!svg) return;
    var show = visible && (_state.front.imageUrl || _state.front.file);
    svg.style.display = show ? '' : 'none';
    if (!show) {
      _layoutArtFrame();
      return;
    }
    _syncHumpColor();
    requestAnimationFrame(function () { _drawHangingOverlay(); });
  }

  function _drawHangingOverlay() {
    var frame = _layoutArtFrame();
    if (!frame) return;

    var svg = document.getElementById('zug-af-hang-combined');
    var stage = document.getElementById('zug-af-stage');
    if (!svg || !stage) return;

    var fitted = _computeFittedSize();
    var physH = fitted.h;
    if (!physH) return;

    var body800 = _getBody800Bounds();
    var containScale = frame.size / 800;

    var bodyTopY800 = (_state.detectedBodyTopY800 != null) ? _state.detectedBodyTopY800 : body800.y;
    var bodyTopY = frame.top + bodyTopY800 * containScale;
    var bodyH = body800.h * containScale;
    var bodyCenterX = frame.left + (body800.x + body800.w / 2) * containScale;
    var bodyPpi = bodyH / physH;

    var humpBodySvgH = AF_HANGER_SVG_VB_H - AF_HANGER_HUMP_TOP_Y;
    var unitsPerInch = humpBodySvgH / AF_HANGER_TOTAL_H_IN;
    var svgHeightPx = (AF_HANGER_SVG_VB_H / unitsPerInch) * bodyPpi;
    var svgWidthPx = svgHeightPx * (AF_HANGER_SVG_VB_W / AF_HANGER_SVG_VB_H);

    var humpTopFrac = AF_HANGER_HUMP_TOP_Y / AF_HANGER_SVG_VB_H;
    var stickoutPx = AF_HANGER_STICKOUT_IN * bodyPpi;
    var svgTopY = (bodyTopY - stickoutPx) - (humpTopFrac * svgHeightPx);
    var svgLeftX = bodyCenterX - svgWidthPx / 2;

    svg.style.width = svgWidthPx + 'px';
    svg.style.height = svgHeightPx + 'px';
    svg.style.left = svgLeftX + 'px';
    svg.style.top = svgTopY + 'px';

    if (!_hangResizeObs && window.ResizeObserver) {
      _hangResizeObs = new ResizeObserver(function () {
        var s = document.getElementById('zug-af-hang-combined');
        if (s && s.style.display !== 'none') _drawHangingOverlay();
      });
      _hangResizeObs.observe(stage);
    }
  }

  function _dominantOpaqueColor(data) {
    var counts = {};
    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 128) continue;
      var r = (data[i] >> 4) << 4;
      var g = (data[i + 1] >> 4) << 4;
      var b = (data[i + 2] >> 4) << 4;
      var key = r + ',' + g + ',' + b;
      counts[key] = (counts[key] || 0) + 1;
    }
    var best = null, max = 0;
    for (var k in counts) {
      if (counts[k] > max) { max = counts[k]; best = k; }
    }
    if (!best) return null;
    var p = best.split(',');
    return '#' + p.map(function (v) { return ('0' + parseInt(v).toString(16)).slice(-2); }).join('');
  }

  function _sampleBorderColorFromSource(sourceImg) {
    var body800 = _getBody800Bounds();
    var c = document.createElement('canvas');
    c.width = 800; c.height = 800;
    var ctx = c.getContext('2d');
    var nw = sourceImg.naturalWidth || sourceImg.width;
    var nh = sourceImg.naturalHeight || sourceImg.height;
    var scale = Math.min(800 / nw, 800 / nh);
    var rw = nw * scale, rh = nh * scale;
    var rx = (800 - rw) / 2, ry = (800 - rh) / 2;
    ctx.drawImage(sourceImg, rx, ry, rw, rh);
    var cx = Math.round(body800.x + body800.w / 2);
    var scanStartY = Math.max(0, Math.round(body800.y));
    var scanH = Math.min(Math.round(body800.h), 800 - scanStartY);
    if (scanH <= 0) return null;
    var col = ctx.getImageData(cx, scanStartY, 1, scanH);
    var topY = null;
    for (var i = 0; i < col.data.length; i += 4) {
      if (col.data[i + 3] >= 128) {
        topY = scanStartY + (i / 4);
        break;
      }
    }
    if (topY !== null) {
      var sw = 30, sh = 8;
      var sx = Math.max(0, Math.min(cx - Math.round(sw / 2), 800 - sw));
      var sy = Math.max(0, Math.min(Math.round(topY + 2), 800 - sh));
      var imageData = ctx.getImageData(sx, sy, sw, sh);
      var color = _dominantOpaqueColor(imageData.data);
      return { color: color, topY: topY };
    }
    return null;
  }

  function _sampleBorderColor() {
    var side = _state.activeSide || 'front';
    if (side === 'front') {
      _state.detectedBorderColor = null;
      _state.detectedBodyTopY800 = null;
    } else {
      _state.back.detectedBorderColor = null;
    }
    var previewImg = document.getElementById('zug-af-modal-preview-img');
    if (previewImg && previewImg.naturalWidth) {
      try {
        var res = _sampleBorderColorFromSource(previewImg);
        console.log('[ZUG-AF] border sample side=' + side + ':', res);
        if (res) {
          if (side === 'front') {
            _state.detectedBorderColor = res.color;
            _state.detectedBodyTopY800 = res.topY;
          } else {
            _state.back.detectedBorderColor = res.color;
          }
        }
      } catch (e) {
        console.warn('[ZUG-AF] border color sampling from preview failed', e);
      }
    }
    var detected = side === 'front' ? _state.detectedBorderColor : _state.back.detectedBorderColor;
    if (!detected && _state.previewUrl) {
      var tmp = new Image();
      tmp.onload = function () {
        try {
          var res2 = _sampleBorderColorFromSource(tmp);
          if (res2) {
            if (side === 'front') {
              _state.detectedBorderColor = res2.color;
              _state.detectedBodyTopY800 = res2.topY;
            } else {
              _state.back.detectedBorderColor = res2.color;
            }
          }
        } catch (e) {
          console.warn('[ZUG-AF] border color sampling from previewUrl failed', e);
        }
        _syncHumpColor();
      };
      tmp.onerror = function () {
        console.warn('[ZUG-AF] previewUrl image load failed for border sampling');
        _syncHumpColor();
      };
      tmp.src = _state.previewUrl;
      return;
    }
    _syncHumpColor();
  }

  function _getActiveHumpColor() {
    var side = _state.activeSide || 'front';
    var fill, detected;
    if (side === 'front') {
      fill = _state.fillColor;
      detected = _state.detectedBorderColor;
    } else if (_state.printStyle === 'mirrored') {
      fill = _state.fillColor;
      detected = _state.detectedBorderColor;
    } else {
      fill = _state.backBgColor;
      detected = _state.back.detectedBorderColor;
    }
    var result = fill || detected || '#4a4a4a';
    console.log('[ZUG-AF] _getActiveHumpColor:', result, '| side:', side, '| fill:', fill, '| detected:', detected);
    return result;
  }

  function _syncHumpColor() {
    _updateHumpColor(_getActiveHumpColor());
    _syncPresetBodyFill();
  }

  function _updateHumpColor(color) {
    var humpPath = document.getElementById('zug-af-hang-hump-path');
    if (humpPath) humpPath.setAttribute('fill', color || '#4a4a4a');
  }

  function _syncPresetBodyFill() {
    if (_state.shape === 'die_cut') return;
    var color = _getActiveHumpColor();

    if (_state._frontEditor && _state._frontEditorReady) {
      if (_state._presetBodyFill) {
        _state._presetBodyFill.set('fill', color);
        _state._frontEditor.canvas.requestRenderAll();
      } else {
        var cutlineD = _getCutlinePathD();
        if (cutlineD) {
          var fill = new fabric.Path(cutlineD, {
            fill: color,
            stroke: 'transparent',
            selectable: false,
            evented: false
          });
          _state._frontEditor.canvas.add(fill);
          fill.sendToBack();
          _state._presetBodyFill = fill;
          _state._frontEditor.canvas.requestRenderAll();
        }
      }
    }

    if (_state._backEditor && _state._backEditorReady) {
      if (_state._presetBackBodyFill) {
        _state._presetBackBodyFill.set('fill', color);
        _state._backEditor.canvas.requestRenderAll();
      } else {
        var backPathD = _state._backEditor.cfg && _state._backEditor.cfg.mask && _state._backEditor.cfg.mask.d;
        if (backPathD) {
          var backFill = new fabric.Path(backPathD, {
            fill: color,
            stroke: 'transparent',
            selectable: false,
            evented: false
          });
          _state._backEditor.canvas.add(backFill);
          backFill.sendToBack();
          _state._presetBackBodyFill = backFill;
          _state._backEditor.canvas.requestRenderAll();
        }
      }
    }
  }

  function _syncSideToggle() {
    var toggle = document.getElementById('zug-af-side-toggle');
    var chipFront = document.getElementById('zug-af-chip-front');
    var chipBack = document.getElementById('zug-af-chip-back');
    if (!toggle) return;

    var hasFront = _state.front.imageUrl || _state.front.file;
    var hasBack = _hasBackPreview();
    toggle.style.display = hasFront ? 'flex' : 'none';

    if (chipBack) {
      chipBack.disabled = !hasBack;
      chipBack.style.opacity = hasBack ? '1' : '0.4';
    }

    if (_state.activeSide === 'back' && !hasBack) {
      _state.activeSide = 'front';
    }

    if (chipFront) chipFront.classList.toggle('is-active', _state.activeSide === 'front');
    if (chipBack) chipBack.classList.toggle('is-active', _state.activeSide === 'back');
  }

  function _switchPreviewSide(side) {
    if (side !== 'front' && side !== 'back') return;
    if (side === 'back' && !_hasBackPreview()) return;
    console.log('[ZUG-AF-SIDE] _switchPreviewSide:', side, '| from:', _state.activeSide, '| panel:', _state.currentPanel, '| shape:', _state.shape);

    if (side === 'back' && _state.printStyle === 'double' && _state.currentPanel !== 'back') {
      _switchPanel('back');
    }
    if (side === 'front' && _state.currentPanel === 'back') {
      _switchPanel(_state._prevNonBackPanel || 'shape');
    }

    _state.activeSide = side;
    _syncSideToggle();

    var badgeW = document.getElementById('zug-af-badge-width');
    var badgeH = document.getElementById('zug-af-badge-height');

    if (side === 'front') {
      _hideBackEditor();
      if (_state.shape !== 'die_cut' && _state._frontEditorReady) {
        _showFrontEditor();
      } else {
        _hideFrontEditor();
        var frontDisplay = _state.previewUrl || _state.front.imageUrl;
        if (frontDisplay) _showPreviewImage(frontDisplay);
      }
      _updateCutlineOverlay();
      _updateMirroredNotice();
      if (badgeW) badgeW.style.display = '';
      if (badgeH) badgeH.style.display = '';
    } else {
      _hideFrontEditor();
      if (badgeW) badgeW.style.display = 'none';
      if (badgeH) badgeH.style.display = 'none';
      if (_state.printStyle === 'double' && _state._backEditorReady) {
        _showBackEditor();
      } else if (_state.printStyle === 'mirrored' && _state.shape === 'die_cut') {
        _hideBackEditor();
        _renderMirroredBack();
      } else if (_state.printStyle === 'mirrored' && _state.shape !== 'die_cut') {
        _hideBackEditor();
        if (_state._frontEditorReady) {
          var wrap = document.getElementById('zug-af-front-editor-wrap');
          var stack = document.getElementById('zug-af-preview-stack');
          var toolbar = document.getElementById('zug-af-front-editor-toolbar');
          var modeBtn = document.getElementById('zug-af-front-mode-btn');
          if (_state._frontEditor) {
            _state._frontEditor.setMode('done');
            _state._frontEditor.canvas.discardActiveObject();
            _state._frontEditor.canvas.renderAll();
          }
          if (wrap) wrap.style.display = '';
          if (stack) stack.style.visibility = 'hidden';
          if (toolbar) toolbar.style.display = 'none';
          if (modeBtn) modeBtn.style.display = 'none';
        } else {
          var frontSrc = _state.front.renderedSnapshot || _state.previewUrl || _state.front.imageUrl;
          if (frontSrc) _showPreviewImage(frontSrc);
        }
      } else if (_state.back.imageUrl) {
        _hideBackEditor();
        _showPreviewImage(_state.back.imageUrl);
      }
      _updateCutlineOverlay();
      _updateMirroredNotice();
    }
    _extractColorPalette();
    _updateStatusBar();
    _syncHumpColor();
    console.log('[ZUG-AF] switched preview side:', side);
  }

  function _renderMirroredBack() {
    var frontSrc = _state.previewUrl || _state.front.imageUrl;
    if (!frontSrc) return;

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var c = document.createElement('canvas');
      c.width = img.naturalWidth;
      c.height = img.naturalHeight;
      var ctx = c.getContext('2d');
      ctx.translate(c.width, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(img, 0, 0);
      var dataUrl = c.toDataURL('image/png');
      _state.back.mirroredDataUrl = dataUrl;
      _state.back.imageUrl = dataUrl;
      _state.back.fileName = _state.front.fileName;
      _state._backImgDims = { w: img.naturalWidth, h: img.naturalHeight };
      if (_state.activeSide === 'back') {
        _showPreviewImage(dataUrl);
      }
      _syncSideToggle();
      console.log('[ZUG-AF] mirrored back rendered');
    };
    img.onerror = function () {
      console.error('[ZUG-AF] mirrored back render failed — back preview NOT available');
      _state.back.mirroredDataUrl = null;
      _state.back.imageUrl = null;
      _state._backImgDims = null;
      if (_state.activeSide === 'back') {
        _state.activeSide = 'front';
        var frontDisplay = _state.previewUrl || _state.front.imageUrl;
        if (frontDisplay) _showPreviewImage(frontDisplay);
      }
      _syncSideToggle();
    };
    img.src = frontSrc;
  }

  function _mirrorSvgPath(d, vbWidth) {
    if (!d) return d;
    vbWidth = vbWidth || 800;
    var tokens = d.match(/[a-zA-Z][^a-zA-Z]*/g);
    if (!tokens) return d;
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
      var seg = tokens[i].trim();
      var cmd = seg.charAt(0);
      var nums = seg.slice(1).trim().replace(/,/g, ' ').split(/\s+/).filter(function (s) { return s.length > 0; }).map(Number);

      if (cmd === 'Z' || cmd === 'z') {
        result.push(cmd);
        continue;
      }
      var isRel = cmd === cmd.toLowerCase();
      var upper = cmd.toUpperCase();

      if (upper === 'M' || upper === 'L' || upper === 'T') {
        for (var j = 0; j < nums.length; j += 2) {
          nums[j] = isRel ? -nums[j] : vbWidth - nums[j];
        }
      } else if (upper === 'H') {
        for (var j = 0; j < nums.length; j++) {
          nums[j] = isRel ? -nums[j] : vbWidth - nums[j];
        }
      } else if (upper === 'V') {
      } else if (upper === 'C') {
        for (var j = 0; j < nums.length; j += 6) {
          nums[j]     = isRel ? -nums[j]     : vbWidth - nums[j];
          nums[j + 2] = isRel ? -nums[j + 2] : vbWidth - nums[j + 2];
          nums[j + 4] = isRel ? -nums[j + 4] : vbWidth - nums[j + 4];
        }
      } else if (upper === 'S') {
        for (var j = 0; j < nums.length; j += 4) {
          nums[j]     = isRel ? -nums[j]     : vbWidth - nums[j];
          nums[j + 2] = isRel ? -nums[j + 2] : vbWidth - nums[j + 2];
        }
      } else if (upper === 'Q') {
        for (var j = 0; j < nums.length; j += 4) {
          nums[j]     = isRel ? -nums[j]     : vbWidth - nums[j];
          nums[j + 2] = isRel ? -nums[j + 2] : vbWidth - nums[j + 2];
        }
      } else if (upper === 'A') {
        for (var j = 0; j < nums.length; j += 7) {
          nums[j + 4] = nums[j + 4] === 0 ? 1 : 0;
          nums[j + 5] = isRel ? -nums[j + 5] : vbWidth - nums[j + 5];
        }
      }
      result.push(cmd + nums.join(' '));
    }
    return result.join(' ');
  }

  function _getCutlinePathD() {
    if (_state.shape !== 'die_cut') {
      var result = _generateShapeCutlinePath();
      return result ? result.path : null;
    }
    if (_state.dieCut.cutline_svg_path) return _state.dieCut.cutline_svg_path;
    return null;
  }

  function _getPathBBox(d) {
    if (!d) return { x: 0, y: 0, w: 800, h: 800 };
    var tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    tmpSvg.setAttribute('viewBox', '0 0 800 800');
    tmpSvg.style.position = 'absolute';
    tmpSvg.style.visibility = 'hidden';
    tmpSvg.style.width = '800px';
    tmpSvg.style.height = '800px';
    var tmpPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    tmpPath.setAttribute('d', d);
    tmpSvg.appendChild(tmpPath);
    document.body.appendChild(tmpSvg);
    var bbox = tmpPath.getBBox();
    document.body.removeChild(tmpSvg);
    return { x: bbox.x, y: bbox.y, w: bbox.width, h: bbox.height };
  }

  function _scaleSvgPath(d, scale) {
    if (!d || scale === 1) return d;
    var tokens = d.match(/[a-zA-Z][^a-zA-Z]*/g);
    if (!tokens) return d;
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
      var seg = tokens[i].trim();
      var cmd = seg.charAt(0);
      if (cmd === 'Z' || cmd === 'z') { result.push(cmd); continue; }
      var nums = seg.slice(1).trim().replace(/,/g, ' ').split(/\s+/).filter(function (s) { return s.length > 0; }).map(Number);
      var upper = cmd.toUpperCase();
      if (upper === 'A') {
        for (var j = 0; j < nums.length; j += 7) {
          nums[j] *= scale; nums[j+1] *= scale;
          nums[j+5] *= scale; nums[j+6] *= scale;
        }
      } else {
        for (var j = 0; j < nums.length; j++) { nums[j] *= scale; }
      }
      result.push(cmd + nums.join(' '));
    }
    return result.join('');
  }

  function _setBackBgShape(color) {
    var editor = _state._backEditor;
    if (!editor || !editor.canvas) return;
    if (_state._backBgShape) {
      if (!color) {
        editor.canvas.remove(_state._backBgShape);
        _state._backBgShape = null;
        if (_state._presetBackBodyFill) _state._presetBackBodyFill.sendToBack();
      } else {
        _state._backBgShape.set({ fill: color });
      }
      editor.canvas.requestRenderAll();
      return;
    }
    if (!color) return;
    var pathD = editor.cfg.mask && editor.cfg.mask.d;
    if (!pathD) return;
    var shape = new fabric.Path(pathD, {
      fill: color,
      stroke: null,
      selectable: false,
      evented: false,
      excludeFromExport: true
    });
    _state._backBgShape = shape;
    editor.canvas.add(shape);
    shape.sendToBack();
    if (_state._presetBackBodyFill) _state._presetBackBodyFill.sendToBack();
    editor.canvas.requestRenderAll();
  }

  function _initFrontPlacementEditor() {
    console.log('[ZUG-AF-EDITOR] _initFrontPlacementEditor called | shape:', _state.shape, '| activeSide:', _state.activeSide);
    if (_state.shape === 'die_cut') return;
    if (!_state.front.originalDataUrl) return;
    if (typeof window.ZugPlacementEditor === 'undefined' || typeof fabric === 'undefined') {
      console.warn('[ZUG-AF] ZugPlacementEditor or Fabric.js not loaded for front editor');
      return;
    }

    var cutlineD = _getCutlinePathD();
    if (!cutlineD) {
      console.warn('[ZUG-AF] no cutline path for front editor');
      return;
    }

    var editorSize = 800;
    var bbox = _getPathBBox(cutlineD);

    var wrap = document.getElementById('zug-af-front-editor-wrap');
    var canvasEl = document.getElementById('zug-af-front-editor-canvas');
    if (!wrap || !canvasEl) return;

    if (_state._frontEditor) {
      try { _state._frontEditor.canvas.dispose(); } catch (e) {}
      _state._frontEditor = null;
      _state._frontBgShape = null;
      _state._presetBodyFill = null;
    }

    canvasEl.width = editorSize;
    canvasEl.height = editorSize;

    var config = {
      canvas: { width: editorSize, height: editorSize },
      mask: {
        type: 'path',
        d: cutlineD,
        bbox: bbox
      },
      bleed: 0,
      defaultMode: 'fit',
      enforceCoverage: false,
      _ui: {
        dimOutsideMask: true,
        dimOpacityEdit: 0.55,
        dimOpacityDone: 0,
        outlineColor: 'transparent'
      }
    };

    try {
      var editor = new window.ZugPlacementEditor({
        canvasEl: canvasEl,
        artImageUrl: _state.front.originalDataUrl,
        templateId: 'af-front-' + (_state.shape || 'oval'),
        templateConfig: config,
        onWarningChange: function (msg) {
          console.log('[ZUG-AF] front editor warning:', msg);
        }
      });
      _state._frontEditor = editor;
      editor.init().then(function () {
        if (_state._frontEditor !== editor) return;
        _state._frontEditorReady = true;
        if (_state.frontBgColor) {
          _setFrontBgShape(_state.frontBgColor);
        }
        if (_state.activeSide === 'front') {
          _showFrontEditor();
        }
        if (!_state.detectedBorderColor) {
          _sampleBorderColor();
        }
        _syncPresetBodyFill();
        console.log('[ZUG-AF] front placement editor initialized');
      }).catch(function (err) {
        if (_state._frontEditor === editor) {
          console.error('[ZUG-AF] front editor init failed:', err);
          _state._frontEditorReady = false;
        }
      });
    } catch (err) {
      console.error('[ZUG-AF] front editor constructor failed:', err);
      _state._frontEditorReady = false;
    }
  }

  function _showFrontEditor() {
    var wrap = document.getElementById('zug-af-front-editor-wrap');
    var stack = document.getElementById('zug-af-preview-stack');
    if (wrap && _state._frontEditorReady) {
      wrap.style.display = '';
      if (stack) stack.style.visibility = 'hidden';
      if (_state._frontEditor) {
        _state._frontEditor.setMode('edit');
        _applyFrontEditorModeUI('edit');
      }
    }
  }

  function _hideFrontEditor() {
    var wrap = document.getElementById('zug-af-front-editor-wrap');
    var stack = document.getElementById('zug-af-preview-stack');
    var toolbar = document.getElementById('zug-af-front-editor-toolbar');
    var modeBtn = document.getElementById('zug-af-front-mode-btn');
    if (wrap) wrap.style.display = 'none';
    if (stack) stack.style.visibility = '';
    if (toolbar) toolbar.style.display = 'none';
    if (modeBtn) modeBtn.style.display = 'none';
    if (_state._frontEditor) _state._frontEditor.setMode('done');
  }

  function _applyFrontEditorModeUI(mode) {
    var toolbar = document.getElementById('zug-af-front-editor-toolbar');
    var modeBtn = document.getElementById('zug-af-front-mode-btn');
    if (mode === 'edit') {
      if (toolbar) { toolbar.style.display = 'flex'; toolbar.classList.remove('zug-placement__toolbar--hidden'); }
      if (modeBtn) { modeBtn.style.display = 'block'; modeBtn.textContent = 'Done'; modeBtn.classList.add('zug-placement__mode-btn--done'); }
    } else {
      if (toolbar) toolbar.classList.add('zug-placement__toolbar--hidden');
      if (modeBtn) { modeBtn.style.display = 'block'; modeBtn.textContent = 'Edit'; modeBtn.classList.remove('zug-placement__mode-btn--done'); }
    }
  }

  function _captureFrontEditorSnapshot() {
    if (!_state._frontEditor || !_state._frontEditorReady) return;
    var editor = _state._frontEditor;
    editor.setMode('done');
    try {
      var handler = editor._afterRenderHandler;
      if (handler) editor.canvas.off('after:render', handler);
      editor.canvas.requestRenderAll();
      var fullDataUrl = editor.canvas.toDataURL({ format: 'png' });
      _state.previewUrl = fullDataUrl;
      var bbox = editor.cfg.mask && editor.cfg.mask.bbox;
      var croppedOpts = { format: 'png' };
      if (bbox) {
        croppedOpts.left = bbox.x;
        croppedOpts.top = bbox.y;
        croppedOpts.width = bbox.w;
        croppedOpts.height = bbox.h;
      }
      var croppedDataUrl = editor.canvas.toDataURL(croppedOpts);
      if (handler) editor.canvas.on('after:render', handler);
      _state.front.imageUrl = croppedDataUrl;
      _state.front.renderedSnapshot = croppedDataUrl;
      var w = bbox ? bbox.w : editor.canvas.getWidth();
      var h = bbox ? bbox.h : editor.canvas.getHeight();
      _state._frontImgDims = { w: w, h: h };
    } catch (err) {
      console.error('[ZUG-AF] front editor snapshot failed:', err);
    }
  }

  function _setFrontBgShape(color) {
    if (!_state._frontEditor || !_state._frontEditorReady) {
      _state.frontBgColor = color;
      return;
    }
    var editor = _state._frontEditor;
    if (_state._frontBgShape) {
      editor.canvas.remove(_state._frontBgShape);
      _state._frontBgShape = null;
    }
    if (!color) {
      if (_state._presetBodyFill) _state._presetBodyFill.sendToBack();
      editor.canvas.requestRenderAll();
      return;
    }
    var cutlineD = _getCutlinePathD();
    if (!cutlineD) return;
    var bg = new fabric.Path(cutlineD, {
      fill: color,
      stroke: 'transparent',
      selectable: false,
      evented: false,
      excludeFromExport: false
    });
    editor.canvas.add(bg);
    bg.sendToBack();
    _state._frontBgShape = bg;
    if (_state._presetBodyFill) _state._presetBodyFill.sendToBack();
    editor.canvas.requestRenderAll();
  }

  function _initBackPlacementEditor() {
    if (_state.printStyle !== 'double') return;
    if (!_state.back.imageUrl) return;
    if (typeof window.ZugPlacementEditor === 'undefined' || typeof fabric === 'undefined') {
      console.warn('[ZUG-AF] ZugPlacementEditor or Fabric.js not loaded');
      return;
    }

    var cutlineD = _getCutlinePathD();
    if (!cutlineD) {
      console.warn('[ZUG-AF] no cutline path for back editor');
      return;
    }

    var mirroredD = _mirrorSvgPath(cutlineD, 800);
    var editorSize = 800;
    var bbox = _getPathBBox(mirroredD);

    var wrap = document.getElementById('zug-af-back-editor-wrap');
    var canvasEl = document.getElementById('zug-af-back-editor-canvas');
    if (!wrap || !canvasEl) return;

    if (_state._backEditor) {
      try { _state._backEditor.canvas.dispose(); } catch (e) {}
      _state._backEditor = null;
      _state._backBgShape = null;
      _state._presetBackBodyFill = null;
    }

    canvasEl.width = editorSize;
    canvasEl.height = editorSize;

    var config = {
      canvas: { width: editorSize, height: editorSize },
      mask: {
        type: 'path',
        d: mirroredD,
        bbox: bbox
      },
      bleed: 0,
      defaultMode: 'fit',
      enforceCoverage: false,
      _ui: {
        dimOutsideMask: true,
        dimOpacityEdit: 0.55,
        dimOpacityDone: 0,
        outlineColor: 'transparent'
      }
    };

    try {
      var editor = new window.ZugPlacementEditor({
        canvasEl: canvasEl,
        artImageUrl: _state.back.imageUrl,
        templateId: 'af-back-' + (_state.shape || 'oval'),
        templateConfig: config,
        onWarningChange: function (msg) {
          console.log('[ZUG-AF] back editor warning:', msg);
        }
      });
      _state._backEditor = editor;
      editor.init().then(function () {
        if (_state._backEditor !== editor) return;
        _state._backEditorReady = true;
        if (_state.backBgColor) {
          _setBackBgShape(_state.backBgColor);
        }
        _syncPresetBodyFill();
        if (_state.currentPanel === 'back' && _state.activeSide === 'back') {
          _showBackEditor();
        }
        console.log('[ZUG-AF] back placement editor initialized');
      }).catch(function (err) {
        if (_state._backEditor === editor) {
          console.error('[ZUG-AF] back editor init failed:', err);
          _state._backEditorReady = false;
        }
      });
    } catch (err) {
      console.error('[ZUG-AF] back editor constructor failed:', err);
      _state._backEditorReady = false;
    }
  }

  function _showBackEditor() {
    var wrap = document.getElementById('zug-af-back-editor-wrap');
    var stack = document.getElementById('zug-af-preview-stack');
    var toolbar = document.getElementById('zug-af-back-editor-toolbar');
    var modeBtn = document.getElementById('zug-af-back-mode-btn');
    if (wrap && _state._backEditorReady) {
      wrap.style.display = '';
      if (stack) stack.style.visibility = 'hidden';
      if (_state._backEditor) {
        _state._backEditor.setMode('edit');
        _applyBackEditorModeUI('edit');
      }
    }
  }

  function _hideBackEditor() {
    var wrap = document.getElementById('zug-af-back-editor-wrap');
    var stack = document.getElementById('zug-af-preview-stack');
    var toolbar = document.getElementById('zug-af-back-editor-toolbar');
    var modeBtn = document.getElementById('zug-af-back-mode-btn');
    if (wrap) wrap.style.display = 'none';
    if (stack) stack.style.visibility = '';
    if (toolbar) toolbar.style.display = 'none';
    if (modeBtn) modeBtn.style.display = 'none';
    if (_state._backEditor) _state._backEditor.setMode('done');
  }

  function _applyBackEditorModeUI(mode) {
    var toolbar = document.getElementById('zug-af-back-editor-toolbar');
    var modeBtn = document.getElementById('zug-af-back-mode-btn');
    if (mode === 'edit') {
      if (toolbar) { toolbar.style.display = 'flex'; toolbar.classList.remove('zug-placement__toolbar--hidden'); }
      if (modeBtn) { modeBtn.style.display = 'block'; modeBtn.textContent = 'Done'; modeBtn.classList.add('zug-placement__mode-btn--done'); }
    } else {
      if (toolbar) toolbar.classList.add('zug-placement__toolbar--hidden');
      if (modeBtn) { modeBtn.style.display = 'block'; modeBtn.textContent = 'Edit'; modeBtn.classList.remove('zug-placement__mode-btn--done'); }
    }
  }

  function _captureBackEditorSnapshot() {
    if (!_state._backEditor || !_state._backEditorReady) return;
    var editor = _state._backEditor;
    editor.setMode('done');
    try {
      var handler = editor._afterRenderHandler;
      if (handler) editor.canvas.off('after:render', handler);
      editor.canvas.requestRenderAll();
      var bbox = editor.cfg.mask && editor.cfg.mask.bbox;
      var exportOpts = { format: 'png' };
      if (bbox) {
        exportOpts.left = bbox.x;
        exportOpts.top = bbox.y;
        exportOpts.width = bbox.w;
        exportOpts.height = bbox.h;
      }
      var dataUrl = editor.canvas.toDataURL(exportOpts);
      if (handler) editor.canvas.on('after:render', handler);
      _state.back.renderedSnapshot = dataUrl;
      var w = bbox ? bbox.w : editor.canvas.getWidth();
      var h = bbox ? bbox.h : editor.canvas.getHeight();
      _state._backImgDims = { w: w, h: h };
    } catch (err) {
      console.error('[ZUG-AF] back editor snapshot failed:', err);
    }
  }

  function _setupBackStep() {
    var mirroredNotice = document.getElementById('zug-af-mirrored-notice');
    var backUploadArea = document.getElementById('zug-af-back-upload-area');
    var backToolbar = document.getElementById('zug-af-back-toolbar');

    if (_state.printStyle === 'mirrored') {
      if (mirroredNotice) mirroredNotice.style.display = 'flex';
      if (backUploadArea) backUploadArea.style.display = 'none';
      _state.activeSide = 'back';

      if (_state.front.imageUrl) {
        _state.back.file = _state.front.file;
        _state.back.fileName = _state.front.fileName;
        if (!_state.back.mirroredDataUrl) {
          _renderMirroredBack();
        }
        if (_state.back.mirroredDataUrl) {
          _showPreviewImage(_state.back.mirroredDataUrl);
        }
      }
      _syncSideToggle();
    } else {
      if (mirroredNotice) mirroredNotice.style.display = 'none';

      if (_state.back.file || _state.back.imageUrl) {
        if (backUploadArea) backUploadArea.style.display = 'none';
        if (backToolbar) backToolbar.style.display = 'none';
        var backFnEl = document.getElementById('zug-af-filename-back');
        if (backFnEl) backFnEl.textContent = _state.back.fileName || 'back artwork';
        _state.activeSide = 'back';
        if (!_state._backEditorReady && !_state._backEditor && _state.back.imageUrl) {
          _initBackPlacementEditor();
        }
        if (_state._backEditorReady) {
          _showBackEditor();
        } else if (_state.back.imageUrl) {
          _showPreviewImage(_state.back.imageUrl);
        }
        _syncSideToggle();
      } else {
        if (backUploadArea) backUploadArea.style.display = 'block';
        if (backToolbar) backToolbar.style.display = 'none';
      }
    }
  }

  async function _addToCart() {
    var approveCheck = document.getElementById('zug-af-approve-check');
    if (!approveCheck || !approveCheck.checked) {
      _showApprovalWarning();
      return;
    }
    if (_state.printStyle === 'double' && !_state.back.file && !_state.back.imageUrl) {
      _showApprovalWarning();
      return;
    }
    if (!_validatePackagingArtworkSelection()) return;

    if (_state._backEditorReady && _state._backEditor) {
      _captureBackEditorSnapshot();
    }

    var submitBtn = document.getElementById('zug-af-confirm-submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Uploading artwork...'; }

    var pricing = getPricing(_state.quantity);
    var shape = SHAPES[_state.shape] || SHAPES.oval;

    var frontUpload = null;
    var backUpload = null;

    if (_state.front.file) {
      frontUpload = await _uploadFileForCart(_state.front.file, _state.front.fileName || 'front.png');
    }
    if (_state.printStyle === 'mirrored' && frontUpload) {
      backUpload = frontUpload;
    } else if (_state.back.file && _state.printStyle !== 'mirrored') {
      backUpload = await _uploadFileForCart(_state.back.file, _state.back.fileName || 'back.png');
    }

    if (submitBtn) submitBtn.textContent = 'Adding to Cart...';

    var fitted = _computeFittedSize();
    var properties = {
      '_is_air_freshener': 'true',
      'Shape': _shapeLabel(_state.shape),
      'Finished Size': fitted.w.toFixed(2) + '" \u00d7 ' + fitted.h.toFixed(2) + '"',
      'Pieces': String(_state.quantity),
      'Fragrance': _state.selectedFragrances.map(function (k) { return _fragranceLabel(k); }).join(', '),
      'Print Style': _state.printStyle === 'mirrored' ? 'Single Mirrored Image' : 'Double Image',
      'Artwork Status': 'Approved',
      '_artwork_mode': 'instant_proof',
      '_af_border_size_in': String(_state.borderSize)
    };
    _applySourceProduct(properties);
    if (_sampleOffer && window.ZUGSampleMode) {
      window.ZUGSampleMode.applyProperties(properties, _sampleOffer);
    }

    if (_state.front.fileName) properties['_af_front_filename'] = _state.front.fileName;
    if (_state.back.fileName) properties['_af_back_filename'] = _state.back.fileName;

    if (frontUpload) {
      properties['_af_front_upload_id'] = frontUpload.upload_id;
      properties['_af_front_preview_url'] = frontUpload.preview_url;
      properties['_af_front_original_url'] = frontUpload.original_url;
    }
    if (backUpload && _state.printStyle !== 'mirrored') {
      properties['_af_back_upload_id'] = backUpload.upload_id;
      properties['_af_back_preview_url'] = backUpload.preview_url;
      properties['_af_back_original_url'] = backUpload.original_url;
    }

    if (_state.dieCut.contourReady) {
      properties['_af_dc_remove_bg'] = _state.dieCut.removeBg ? 'true' : 'false';
      if (_state.dieCut.dcfUploadId) properties['_af_dc_upload_id'] = _state.dieCut.dcfUploadId;
      if (_state.dieCut.processedArtworkUrl) properties['_af_dc_processed_url'] = _state.dieCut.processedArtworkUrl;
      if (_state.dieCut.dcfCutlinePath) properties['_af_dc_cutline_path'] = _state.dieCut.dcfCutlinePath;
      properties['_af_max_w_in'] = String(AF_MAX_FINISHED_W_IN);
      properties['_af_max_h_in'] = String(AF_MAX_FINISHED_H_IN);
      if (_state.shape === 'die_cut') properties['_af_die_cut'] = 'true';
      if (_state.fillColor) properties['_af_fill_color'] = _state.fillColor;
      properties['_af_outline_thickness_px'] = String(_computeThicknessPx());
    }

    if (_state.backBgColor) {
      properties['_af_back_bg_color'] = _state.backBgColor;
    }

    properties['_af_double_sided'] = 'true';

    try {
      await _attachApprovedPackagingArtwork(properties);
    } catch (packagingError) {
      console.error('[ZUG-AF] packaging artwork error:', packagingError);
      alert('Error preparing packaging artwork: ' + packagingError.message);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
      return;
    }

    if (submitBtn) submitBtn.textContent = 'Generating previews...';
    var frontRenderedDataUrl = await _generateRenderedPreview('front');
    var backRenderedDataUrl = await _generateRenderedPreview('back');
    if (frontRenderedDataUrl) {
      var frontBlob = _dataURLtoBlob(frontRenderedDataUrl);
      if (frontBlob) {
        var frontRenderedUpload = await _uploadFileForCart(frontBlob, 'front-rendered.png');
        if (frontRenderedUpload) {
          properties['_af_front_rendered_preview_url'] = frontRenderedUpload.preview_url || frontRenderedUpload.original_url;
        }
      }
    }
    if (backRenderedDataUrl) {
      var backBlob = _dataURLtoBlob(backRenderedDataUrl);
      if (backBlob) {
        var backRenderedUpload = await _uploadFileForCart(backBlob, 'back-rendered.png');
        if (backRenderedUpload) {
          properties['_af_back_rendered_preview_url'] = backRenderedUpload.preview_url || backRenderedUpload.original_url;
        }
      }
    }
    if (submitBtn) submitBtn.textContent = 'Adding to Cart...';

    var surchargeCents = _getAfSurcharges().totalSurchargeCents;
    var totalDesiredCents = Math.round(pricing.total * 100) + surchargeCents;
    var calcLineUid = _generateCalcLineUid();

    try {
      var built = await _addNativeLine(properties, totalDesiredCents, calcLineUid);
      console.log('[ZUG-AF] added exact native line', built.resolution);

      _closeModal();
      _refreshCartAndOpenDrawer();

    } catch (err) {
      console.error('[ZUG-AF] add to cart error:', err);
      alert('Error adding to cart: ' + err.message);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
    }
  }

  async function _addToCartEmailLater() {
    var pricing = getPricing(_state.quantity);
    var shape = SHAPES[_state.shape] || SHAPES.oval;
    var emailSurchargeCents = _getAfSurcharges().totalSurchargeCents;
    var totalDesiredCents = Math.round(pricing.total * 100) + emailSurchargeCents;
    var calcLineUid = _generateCalcLineUid();

    var properties = {
      '_is_air_freshener': 'true',
      'Pieces': String(_state.quantity),
      'Shape': _shapeLabel(_state.shape),
      'Finished Size': shape.width_in + '" \u00d7 ' + shape.height_in + '"',
      'Fragrance': _state.selectedFragrances.map(function (k) { return _fragranceLabel(k); }).join(', '),
      'Print Style': _state.printStyle === 'mirrored' ? 'Single Mirrored Image' : 'Double Image',
      'Artwork Status': 'Upload Later',
      '_artwork_mode': 'email_later'
    };
    _applySourceProduct(properties);
    _applyPackagingStatus(properties, 'Upload Later');
    if (_sampleOffer && window.ZUGSampleMode) {
      window.ZUGSampleMode.applyProperties(properties, _sampleOffer);
    }

    try {
      var built = await _addNativeLine(properties, totalDesiredCents, calcLineUid);
      console.log('[ZUG-AF] added exact native line (email later)', built.resolution);
      _closeModal();
      _refreshCartAndOpenDrawer();
    } catch (err) {
      console.error('[ZUG-AF] email later cart error:', err);
      alert('Error adding to cart: ' + err.message);
    }
  }

  async function _addToCartReorder() {
    var orderNum = (document.getElementById('zug-af-reorder-number') || {}).value || '';
    var reorderNote = (document.getElementById('zug-af-reorder-note') || {}).value || '';
    var pricing = getPricing(_state.quantity);
    var shape = SHAPES[_state.shape] || SHAPES.oval;
    var reorderSurchargeCents = _getAfSurcharges().totalSurchargeCents;
    var totalDesiredCents = Math.round(pricing.total * 100) + reorderSurchargeCents;
    var calcLineUid = _generateCalcLineUid();

    var properties = {
      '_is_air_freshener': 'true',
      'Pieces': String(_state.quantity),
      'Shape': _shapeLabel(_state.shape),
      'Finished Size': shape.width_in + '" \u00d7 ' + shape.height_in + '"',
      'Fragrance': _state.selectedFragrances.map(function (k) { return _fragranceLabel(k); }).join(', '),
      'Print Style': _state.printStyle === 'mirrored' ? 'Single Mirrored Image' : 'Double Image',
      'Artwork Status': 'Reorder',
      '_artwork_mode': 'reorder',
      '_reorder_number': orderNum.trim()
    };
    _applySourceProduct(properties);
    _applyPackagingStatus(properties, 'Reorder');
    if (_sampleOffer && window.ZUGSampleMode) {
      window.ZUGSampleMode.applyProperties(properties, _sampleOffer);
    }
    if (reorderNote.trim()) properties['_reorder_note'] = reorderNote.trim();

    try {
      var built = await _addNativeLine(properties, totalDesiredCents, calcLineUid);
      console.log('[ZUG-AF] added exact native line (reorder)', built.resolution);
      _closeModal();
      _refreshCartAndOpenDrawer();
    } catch (err) {
      console.error('[ZUG-AF] reorder cart error:', err);
      alert('Error adding to cart: ' + err.message);
    }
  }


  var _uploadStepFile = null;
  var _uploadMethod = 'instant_proof';

  function _openModal(opts) {
    opts = opts || {};
    _resetState();
    _uploadStepFile = null;
    _uploadMethod = 'instant_proof';

    console.log('[ZUG-AF-SHAPE] _openModal shape from opts:', opts.shape, '| post-reset:', _state.shape);
    if (opts.shape) _state.shape = opts.shape;
    if (opts.fragrance) _state.fragrance = opts.fragrance;
    if (opts.printStyle) _state.printStyle = opts.printStyle;
    if (opts.quantity) _state.quantity = opts.quantity;

    var modal = document.getElementById('zug-af-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var container = modal.querySelector('.zug-af-modal__container');
    if (container) {
      container.classList.remove('zug-af-modal__container--builder');
      container.classList.remove('zug-modal__container--builder');
    }

    var titleEl = document.getElementById('zug-af-modal-title');
    if (titleEl) titleEl.textContent = 'Upload Your Artwork';

    var stepUpload = document.getElementById('zug-af-step-upload');
    var stepBuilder = document.getElementById('zug-af-step-builder');
    if (stepUpload) stepUpload.style.display = '';
    if (stepBuilder) stepBuilder.style.display = 'none';

    _resetUploadStep();
    _syncDualUploadVisibility();

    console.log('[ZUG-AF] modal opened (upload step)', _state);
  }

  function _syncDualUploadVisibility() {
    var singleZone = document.getElementById('zug-af-upload-zone-initial');
    var singlePreview = document.getElementById('zug-af-upload-preview');
    var dualUpload = document.getElementById('zug-af-dual-upload');
    var isDouble = _state.printStyle === 'double';

    if (dualUpload) dualUpload.style.display = isDouble ? '' : 'none';
    if (isDouble) {
      if (singleZone) singleZone.style.display = 'none';
      if (singlePreview) singlePreview.style.display = 'none';
    }
  }

  function _resetUploadStep() {
    var uploadZone = document.getElementById('zug-af-upload-zone-initial');
    var preview = document.getElementById('zug-af-upload-preview');
    var processing = document.getElementById('zug-af-upload-processing');
    var continueBtn = document.getElementById('zug-af-upload-continue');
    var inputEl = document.getElementById('zug-af-input-initial');

    if (uploadZone) uploadZone.style.display = '';
    if (preview) preview.style.display = 'none';
    if (processing) processing.style.display = 'none';
    if (continueBtn) continueBtn.disabled = true;
    if (inputEl) inputEl.value = '';

    _uploadStepFile = null;

    var methodCards = document.querySelectorAll('.zug-af-method-card');
    methodCards.forEach(function (card) {
      card.classList.toggle('zug-af-method-card--active', card.dataset.method === 'instant_proof');
    });

    var instantPanel = document.getElementById('zug-af-method-instant');
    var emailPanel = document.getElementById('zug-af-method-email');
    var reorderPanel = document.getElementById('zug-af-method-reorder');
    if (instantPanel) instantPanel.style.display = '';
    if (emailPanel) emailPanel.style.display = 'none';
    if (reorderPanel) reorderPanel.style.display = 'none';

    var reorderNumber = document.getElementById('zug-af-reorder-number');
    var reorderNote = document.getElementById('zug-af-reorder-note');
    if (reorderNumber) reorderNumber.value = '';
    if (reorderNote) reorderNote.value = '';

    _uploadMethod = 'instant_proof';

    _resetDualUploadSlots();
    _updateUploadContinueState();
  }

  function _resetDualUploadSlots() {
    ['front', 'back'].forEach(function (side) {
      var slot = document.getElementById('zug-af-dual-slot-' + side);
      var empty = document.getElementById('zug-af-dual-' + side + '-empty');
      var done = document.getElementById('zug-af-dual-' + side + '-done');
      var input = document.getElementById('zug-af-dual-input-' + side);
      if (slot) slot.classList.remove('is-complete');
      if (empty) empty.style.display = '';
      if (done) done.style.display = 'none';
      if (input) input.value = '';
    });
    _state._dualFrontFile = null;
    _state._dualBackFile = null;
  }

  function _updateUploadContinueState() {
    var continueBtn = document.getElementById('zug-af-upload-continue');
    if (!continueBtn) return;
    if (_uploadMethod === 'email_later') {
      continueBtn.disabled = false;
      continueBtn.textContent = 'Continue';
    } else if (_uploadMethod === 'reorder') {
      var orderNum = document.getElementById('zug-af-reorder-number');
      continueBtn.disabled = !(orderNum && orderNum.value.trim());
      continueBtn.textContent = 'Continue';
    } else if (_state.printStyle === 'double') {
      continueBtn.disabled = !_state._dualFrontFile;
      continueBtn.textContent = 'Continue';
    } else {
      continueBtn.disabled = !_uploadStepFile;
      continueBtn.textContent = 'Continue';
    }
  }

  function _handleUploadStepFile(file) {
    if (!file) return;
    _uploadStepFile = file;

    var uploadZone = document.getElementById('zug-af-upload-zone-initial');
    var preview = document.getElementById('zug-af-upload-preview');
    var filenameEl = document.getElementById('zug-af-upload-filename');

    if (uploadZone) uploadZone.style.display = 'none';
    if (preview) preview.style.display = '';
    if (filenameEl) filenameEl.textContent = file.name;

    _updateUploadContinueState();
  }

  function _removeUploadStepFile() {
    _uploadStepFile = null;

    var uploadZone = document.getElementById('zug-af-upload-zone-initial');
    var preview = document.getElementById('zug-af-upload-preview');
    var inputEl = document.getElementById('zug-af-input-initial');

    if (uploadZone) uploadZone.style.display = '';
    if (preview) preview.style.display = 'none';
    if (inputEl) inputEl.value = '';

    _updateUploadContinueState();
  }

  async function _transitionToBuilder() {
    if (!_uploadStepFile) return;

    var processing = document.getElementById('zug-af-upload-processing');
    var continueBtn = document.getElementById('zug-af-upload-continue');
    if (processing) processing.style.display = 'block';
    var uploadLoader = processing ? processing.querySelector('.zug-preview-loader') : null;
    if (uploadLoader) uploadLoader.classList.add('active');
    if (continueBtn) continueBtn.disabled = true;

    var file = _uploadStepFile;
    var isRasterImage = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp'].indexOf(file.type) !== -1;

    if (isRasterImage) {
      try {
        var dataUrl = await _readFileAsDataURL(file);
        _state.front.file = file;
        _state.front.fileName = file.name;
        _state.front.imageUrl = dataUrl;
        _state.front.originalDataUrl = dataUrl;

        if (_state.shape === 'die_cut') {
          var dcfResult = await _callDCFPreview(file);
          if (dcfResult) {
            _applyDCFResponse(dcfResult);
            _state.front.imageUrl = _state.previewUrl || dataUrl;
          }
        } else {
          await _renderSimpleShapePreview();
        }
      } catch (err) {
        console.error('[ZUG-AF] upload processing error:', err);
      }
    } else {
      _state.front.file = file;
      _state.front.fileName = file.name;
      _state.front.imageUrl = null;
    }

    if (processing) processing.style.display = 'none';
    if (uploadLoader) uploadLoader.classList.remove('active');

    var container = document.querySelector('.zug-af-modal__container');
    var stepUpload = document.getElementById('zug-af-step-upload');
    var stepBuilder = document.getElementById('zug-af-step-builder');

    if (stepUpload) stepUpload.style.display = 'none';
    if (container) {
      container.classList.add('zug-af-modal__container--builder');
      container.classList.add('zug-modal__container--builder');
    }
    if (stepBuilder) stepBuilder.style.display = '';

    var removeBgCheckbox = document.getElementById('zug-af-remove-bg');
    if (removeBgCheckbox) removeBgCheckbox.checked = _state.dieCut.removeBg;

    var uploadZoneBack = document.getElementById('zug-af-upload-zone-back');
    if (uploadZoneBack) uploadZoneBack.style.display = '';
    var toolbarBack = document.getElementById('zug-af-back-toolbar');
    if (toolbarBack) toolbarBack.style.display = 'none';

    var approveCheck = document.getElementById('zug-af-approve-check');
    if (approveCheck) approveCheck.checked = false;

    _syncBackPanelVisibility();
    _syncBuilderShapeButtons();
    _switchPanel('shape');

    var frontDisplay = _state.previewUrl || _state.front.imageUrl;
    if (frontDisplay) _showPreviewImage(frontDisplay);
    if (!isRasterImage) _showUploadComplete('front', file.name);

    if (_state.shape !== 'die_cut') {
      _initFrontPlacementEditor();
    }

    if (_state.printStyle === 'mirrored' && _state.shape === 'die_cut') {
      _renderMirroredBack();
    }

    _syncSideToggle();
    _updateCutlineOverlay();
    _updateStatusBar();
    _updateGating();
    _positionHangingOverlays(true);

    console.log('[ZUG-AF] transitioned to builder', _state);
  }

  function _closeModal() {
    var modal = document.getElementById('zug-af-modal');
    if (!modal) return;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var container = modal.querySelector('.zug-af-modal__container');
    if (container) {
      container.classList.remove('zug-af-modal__container--builder');
      container.classList.remove('zug-modal__container--builder');
    }
    _resetState();
  }

  function _wireUploadInput(side) {
    var inputId = 'zug-af-input-' + side;
    var input = document.getElementById(inputId);
    if (!input) return;
    input.addEventListener('change', function (e) {
      if (e.target.files && e.target.files[0]) {
        _handleFileUpload(side, e.target.files[0]);
      }
    });
  }

  function _wireUploadZoneDragDrop(side) {
    var zoneId = 'zug-af-upload-zone-' + side;
    var zone = document.getElementById(zoneId);
    if (!zone) return;

    zone.addEventListener('dragover', function (e) {
      e.preventDefault();
      zone.classList.add('is-dragover');
    });
    zone.addEventListener('dragleave', function () {
      zone.classList.remove('is-dragover');
    });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-dragover');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        _handleFileUpload(side, e.dataTransfer.files[0]);
      }
    });
  }

  function _wireEditorToolbar(side) {
    var replaceBtn = document.getElementById('zug-af-replace-' + side);

    if (replaceBtn) replaceBtn.addEventListener('click', function () {
      var input = document.getElementById('zug-af-input-' + side);
      if (!input) {
        var newInput = document.createElement('input');
        newInput.type = 'file';
        newInput.accept = '.png,.jpg,.jpeg,.pdf,.ai,.svg,.psd,.gif,.bmp,.tiff,.webp';
        newInput.addEventListener('change', function (e) {
          if (e.target.files && e.target.files[0]) {
            _handleFileUpload(side, e.target.files[0]);
            if (side === 'back') {
              _state._backEditorReady = false;
              if (_state._backEditor) {
                try { _state._backEditor.canvas.dispose(); } catch (e) {}
                _state._backEditor = null;
              }
            }
          }
        });
        newInput.click();
      } else {
        input.value = '';
        input.click();
      }
    });

    if (side === 'back') {
      var fitBtn = document.getElementById('zug-af-fit-back');
      var fillBtn = document.getElementById('zug-af-fill-back');
      var centerBtn = document.getElementById('zug-af-center-back');
      var editBtn = document.getElementById('zug-af-edit-back');

      if (fitBtn) fitBtn.addEventListener('click', function () {
        if (_state._backEditor && _state._backEditor.art) {
          _state._backEditor.applyFit();
          _state._backEditor.setMode('done');
        }
      });
      if (fillBtn) fillBtn.addEventListener('click', function () {
        if (_state._backEditor && _state._backEditor.art) {
          _state._backEditor.applyFill();
          _state._backEditor.setMode('done');
        }
      });
      if (centerBtn) centerBtn.addEventListener('click', function () {
        if (_state._backEditor && _state._backEditor.art) {
          _state._backEditor.center();
          _state._backEditor.setMode('done');
        }
      });
      if (editBtn) editBtn.addEventListener('click', function () {
        if (_state._backEditor) {
          _state._backEditor.setMode('edit');
        }
      });

      var canvasToolbar = document.getElementById('zug-af-back-editor-toolbar');
      if (canvasToolbar) {
        canvasToolbar.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-action]');
          if (!btn) return;
          var action = btn.getAttribute('data-action');
          if (!_state._backEditor) return;
          if (action === 'fit-back' && _state._backEditor.art) {
            _state._backEditor.applyFit();
          } else if (action === 'fill-back' && _state._backEditor.art) {
            _state._backEditor.applyFill();
          } else if (action === 'center-back' && _state._backEditor.art) {
            _state._backEditor.center();
          } else if (action === 'rot90-back' && _state._backEditor.art) {
            _state._backEditor.rotate90();
          } else if (action === 'reset-back' && _state._backEditor.art) {
            _state._backEditor.applyFit();
            if (_state._backEditor.art) _state._backEditor.art.set({ angle: 0 });
            _state._backEditor.canvas.requestRenderAll();
          }
        });
      }

      var backModeBtn = document.getElementById('zug-af-back-mode-btn');
      if (backModeBtn) {
        backModeBtn.addEventListener('click', function () {
          if (!_state._backEditor) return;
          var current = _state._backEditor._mode || 'done';
          var next = current === 'edit' ? 'done' : 'edit';
          _state._backEditor.setMode(next);
          _applyBackEditorModeUI(next);
        });
      }
    }

    if (side === 'front') {
      var frontToolbar = document.getElementById('zug-af-front-editor-toolbar');
      if (frontToolbar) {
        frontToolbar.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-action]');
          if (!btn) return;
          var action = btn.getAttribute('data-action');
          if (!_state._frontEditor) return;
          if (action === 'fit-front' && _state._frontEditor.art) {
            _state._frontEditor.applyFit();
          } else if (action === 'fill-front' && _state._frontEditor.art) {
            _state._frontEditor.applyFill();
          } else if (action === 'center-front' && _state._frontEditor.art) {
            _state._frontEditor.center();
          } else if (action === 'rot90-front' && _state._frontEditor.art) {
            _state._frontEditor.rotate90();
          } else if (action === 'reset-front' && _state._frontEditor.art) {
            _state._frontEditor.applyFit();
            if (_state._frontEditor.art) _state._frontEditor.art.set({ angle: 0 });
            _state._frontEditor.canvas.requestRenderAll();
          }
        });
      }

      var frontModeBtn = document.getElementById('zug-af-front-mode-btn');
      if (frontModeBtn) {
        frontModeBtn.addEventListener('mousedown', function (e) {
          e.stopPropagation();
        });
        frontModeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!_state._frontEditor) return;
          var current = _state._frontEditor._mode || 'done';
          var next = current === 'edit' ? 'done' : 'edit';
          _state._frontEditor.setMode(next);
          _state._frontEditor.canvas.discardActiveObject();
          _state._frontEditor.canvas.renderAll();
          _applyFrontEditorModeUI(next);
          if (next === 'done') {
            _captureFrontEditorSnapshot();
          }
        });
      }
    }

    {
      var backBgRadios = document.getElementById('zug-af-back-bg-radios');
      var backBgColors = document.getElementById('zug-af-back-bg-colors');
      if (backBgRadios) {
        backBgRadios.addEventListener('change', function (e) {
          var val = e.target.value;
          if (val === 'none') {
            if (backBgColors) backBgColors.style.display = 'none';
            _state.backBgColor = null;
            _setBackBgShape(null);
          } else if (val === 'solid') {
            if (backBgColors) backBgColors.style.display = '';
            var activeColor = backBgColors ? backBgColors.querySelector('.zug-builder__color-swatch--active') : null;
            var color = activeColor ? activeColor.dataset.color : '#FFFFFF';
            _state.backBgColor = color;
            _setBackBgShape(color);
          }
        });
      }
      if (backBgColors) {
        backBgColors.addEventListener('click', function (e) {
          var swatch = e.target.closest('[data-color]');
          if (!swatch) return;
          backBgColors.querySelectorAll('.zug-builder__color-swatch').forEach(function (s) { s.classList.remove('zug-builder__color-swatch--active'); });
          swatch.classList.add('zug-builder__color-swatch--active');
          var color = swatch.dataset.color;
          _state.backBgColor = color;
          _setBackBgShape(color);
        });
      }
    }
  }

  function _getQtySet() {
    if (_sampleOffer) return [Number(_sampleOffer.quantity)];
    if (_dealRecipe && _dealRecipe.key === 'BOGO') return [1, 2, 3, 4, 5];
    if (!_productContractRow) return [];
    var values = _productContractRow.presets.slice();
    if (_productContractRow.allowCustomQuantity) values.push('custom');
    return values;
  }

  function _customQuantityLimits() {
    if (_dealRecipe && _dealRecipe.key === 'BOGO') return { minimum: 1, maximum: 5 };
    var policy = _productContractRow && _productContractRow.customQuantityPolicy;
    return policy
      ? { minimum: policy.minimum, maximum: policy.maximum }
      : { minimum: MIN_QTY, maximum: 10000 };
  }

  function _configureCustomQuantityInput(qtyInput) {
    if (!qtyInput) return;
    var limits = _customQuantityLimits();
    qtyInput.min = String(limits.minimum);
    qtyInput.max = String(limits.maximum);
    qtyInput.step = '1';
  }

  function _commitCustomQuantityInput(qtyInput, reportInvalid) {
    if (!qtyInput) return false;
    if (_dealRecipe && _dealRecipe.key === 'BOGO') {
      var bogoValue = Number(qtyInput.value);
      var bogoValid = Number.isInteger(bogoValue) && bogoValue >= 1 && bogoValue <= 5;
      qtyInput.setCustomValidity(bogoValid ? '' : 'Enter a whole number from 1 to 5.');
      if (!bogoValid) {
        if (reportInvalid) qtyInput.reportValidity();
        return false;
      }
      _state.quantity = bogoValue;
      qtyInput.value = String(bogoValue);
      _updateQtyPresetHighlight();
      _updatePriceDisplay();
      return true;
    }
    var policy = _productContractRow && _productContractRow.customQuantityPolicy;
    if (!policy) {
      var existingValue = parseInt(qtyInput.value, 10);
      if (isNaN(existingValue) || existingValue < MIN_QTY) existingValue = MIN_QTY;
      qtyInput.setCustomValidity('');
      _state.quantity = existingValue;
      qtyInput.value = String(existingValue);
      _updateQtyPresetHighlight();
      _updatePriceDisplay();
      return true;
    }
    var limits = _customQuantityLimits();
    var value = Number(qtyInput.value);
    var valid = Number.isInteger(value) && value >= limits.minimum && value <= limits.maximum;
    if (valid) {
      try {
        getPricing(value);
      } catch (pricingError) {
        valid = false;
      }
    }
    qtyInput.setCustomValidity(valid ? '' : 'Enter a whole number from ' + limits.minimum + ' to ' + limits.maximum + '.');
    if (!valid) {
      if (reportInvalid) qtyInput.reportValidity();
      return false;
    }
    _state.quantity = value;
    qtyInput.value = String(value);
    _updateQtyPresetHighlight();
    _updatePriceDisplay();
    return true;
  }

  function _validateActiveCustomQuantity() {
    var customQtyWrap = document.getElementById('af-custom-qty');
    if (!customQtyWrap || customQtyWrap.style.display === 'none') return true;
    return _commitCustomQuantityInput(document.getElementById('af-qty-input'), true);
  }

  function _renderQtyPresets() {
    var container = document.getElementById('af-qty-presets');
    if (!container) return;
    var set = _getQtySet();
    container.innerHTML = '';
    set.forEach(function (v, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'af-widget__preset';
      if (v === 'custom') {
        btn.dataset.qty = 'custom';
        btn.textContent = 'Custom';
      } else {
        btn.dataset.qty = String(v);
        btn.textContent = v.toLocaleString();
      }
      container.appendChild(btn);
    });
    var firstNumeric = set.find(function (v) { return v !== 'custom'; });
    if (firstNumeric) _state.quantity = firstNumeric;
    _updateQtyPresetHighlight();

    var mode = _productContractRow ? _productContractRow.kind : '';
    var infoBlock = document.getElementById('af-wholesale-info');
    if (infoBlock) infoBlock.style.display = (mode === 'wholesale') ? 'block' : 'none';
  }

  function _applyDealUi(widget) {
    if (!_dealRecipe) return;
    if (_dealRecipe.key === 'BOGO') {
      var bogoTogglePricing = document.getElementById('af-toggle-pricing');
      if (bogoTogglePricing) bogoTogglePricing.hidden = true;
      var bogoPricingList = document.getElementById('af-pricing-list');
      if (bogoPricingList) bogoPricingList.style.display = 'none';
      _state.showPricingList = false;
      var bogoCustomizeBtn = document.getElementById('af-customize-btn');
      if (bogoCustomizeBtn) {
        bogoCustomizeBtn.disabled = false;
        bogoCustomizeBtn.removeAttribute('aria-disabled');
      }
      widget.classList.remove('af-widget--deal-pending');
      widget.classList.add('af-widget--deal', 'af-widget--bogo');
      widget.setAttribute('data-af-deal-recipe', _dealRecipe.key);
      return;
    }
    _state.quantity = _dealRecipe.quantity;
    _state.selectedFragrances = [_state.selectedFragrances[0] || _state.fragrance || 'new_car'];
    _syncFragranceState();

    var qtyPills = document.getElementById('af-qty-pills');
    if (qtyPills) {
      qtyPills.innerHTML = '';
      var lockedQuantity = document.createElement('span');
      lockedQuantity.className = 'af-widget__locked-value';
      lockedQuantity.setAttribute('data-af-locked-quantity', String(_dealRecipe.quantity));
      lockedQuantity.textContent = _dealRecipe.quantity + ' pieces';
      qtyPills.appendChild(lockedQuantity);
    }
    var togglePricing = document.getElementById('af-toggle-pricing');
    if (togglePricing) togglePricing.hidden = true;
    var pricingList = document.getElementById('af-pricing-list');
    if (pricingList) pricingList.style.display = 'none';
    _state.showPricingList = false;

    var priceSection = document.getElementById('af-price-section');
    if (priceSection && !document.getElementById('af-deal-turnaround-section')) {
      var turnaroundSection = document.createElement('div');
      turnaroundSection.className = 'af-widget__section';
      turnaroundSection.id = 'af-deal-turnaround-section';
      turnaroundSection.setAttribute('data-af-turnaround-lock', _dealRecipe.turnaround.key);

      var turnaroundHeader = document.createElement('div');
      turnaroundHeader.className = 'af-widget__header';
      var turnaroundLabel = document.createElement('span');
      turnaroundLabel.className = 'af-widget__label';
      turnaroundLabel.textContent = 'Turnaround';
      turnaroundHeader.appendChild(turnaroundLabel);

      var lockedTurnaround = document.createElement('span');
      lockedTurnaround.className = 'af-widget__locked-value';
      lockedTurnaround.textContent = _dealRecipe.turnaround.label;
      turnaroundSection.appendChild(turnaroundHeader);
      turnaroundSection.appendChild(lockedTurnaround);
      priceSection.parentNode.insertBefore(turnaroundSection, priceSection);
    }

    var fragranceSubtitle = document.getElementById('af-fragrance-modal-subtitle');
    if (fragranceSubtitle) fragranceSubtitle.textContent = 'Choose exactly one fragrance (included)';
    var customizeBtn = document.getElementById('af-customize-btn');
    if (customizeBtn) {
      customizeBtn.disabled = false;
      customizeBtn.removeAttribute('aria-disabled');
    }
    widget.classList.remove('af-widget--deal-pending');
    widget.classList.add('af-widget--deal');
    widget.setAttribute('data-af-deal-recipe', _dealRecipe.key);
  }

  function _initWidget() {
    _renderQtyPresets();
    _initPackagingArtworkInputs();

    var qtyInput = document.getElementById('af-qty-input');
    var qtyPresets = document.getElementById('af-qty-presets');
    var customQtyWrap = document.getElementById('af-custom-qty');

    if (qtyInput) {
      _configureCustomQuantityInput(qtyInput);
      qtyInput.addEventListener('change', function () {
        _commitCustomQuantityInput(qtyInput, true);
      });
    }
    if (qtyPresets) {
      qtyPresets.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty]');
        if (!btn) return;
        var qtyVal = btn.dataset.qty;
        if (qtyVal === 'custom') {
          _showCustomQtyInput();
          return;
        }
        var val = parseInt(qtyVal, 10);
        _state.quantity = val;
        if (customQtyWrap) customQtyWrap.style.display = 'none';
        if (qtyInput) qtyInput.value = '';
        _updateQtyPresetHighlight();
        _updatePriceDisplay();
      });
    }

    var togglePricing = document.getElementById('af-toggle-pricing');
    if (togglePricing) {
      togglePricing.addEventListener('click', function () {
        _state.showPricingList = !_state.showPricingList;
        var pills = document.getElementById('af-qty-pills');
        var list = document.getElementById('af-pricing-list');
        var toggleText = document.getElementById('af-toggle-text');
        var toggleIcon = document.getElementById('af-toggle-icon');
        if (pills) pills.style.display = _state.showPricingList ? 'none' : 'block';
        if (list) list.style.display = _state.showPricingList ? 'block' : 'none';
        if (toggleText) toggleText.textContent = _state.showPricingList ? 'Hide pricing list' : 'View pricing list';
        if (toggleIcon) toggleIcon.innerHTML = _state.showPricingList ? '<path d="m18 15-6-6-6 6"/>' : '<path d="m6 9 6 6 6-6"/>';
        if (_state.showPricingList) _updatePricingList();
      });
    }

    var fragranceTrigger = document.getElementById('af-fragrance-trigger');
    if (fragranceTrigger) {
      fragranceTrigger.addEventListener('click', function () { _openFragranceModal(); });
    }
    var fragModalClose = document.getElementById('af-fragrance-modal-close');
    if (fragModalClose) fragModalClose.addEventListener('click', function () { _closeFragranceModal(); });
    var fragModalOverlay = document.getElementById('af-fragrance-modal-overlay');
    if (fragModalOverlay) fragModalOverlay.addEventListener('click', function () { _closeFragranceModal(); });
    var fragModalApply = document.getElementById('af-fragrance-modal-apply');
    if (fragModalApply) fragModalApply.addEventListener('click', function () { _applyFragranceSelection(); });

    var shapeBtns = document.getElementById('af-shape-buttons');
    if (shapeBtns) {
      shapeBtns.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-shape]');
        if (!btn || btn.disabled) return;
        shapeBtns.querySelectorAll('.af-widget__icon-btn').forEach(function (b) { b.classList.remove('af-widget__icon-btn--active'); });
        btn.classList.add('af-widget__icon-btn--active');
        console.log('[ZUG-AF-SHAPE] PDP shape btn clicked:', btn.dataset.shape, '| prev:', _state.shape);
        _state.shape = btn.dataset.shape;
        var valEl = document.getElementById('af-shape-value');
        if (valEl) valEl.textContent = btn.title;
      });
    }

    var printStyleBtns = document.getElementById('af-print-style-buttons');
    if (printStyleBtns) {
      printStyleBtns.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-print-style]');
        if (!btn) return;
        printStyleBtns.querySelectorAll('.af-widget__opt-btn').forEach(function (b) { b.classList.remove('af-widget__opt-btn--active'); });
        btn.classList.add('af-widget__opt-btn--active');
        _state.printStyle = btn.dataset.printStyle;
        var valEl = document.getElementById('af-print-style-value');
        if (valEl) valEl.textContent = btn.title || btn.textContent;
        _updatePriceDisplay();
        if (_state.showPricingList) _updatePricingList();
      });
    }

    var customizeBtn = document.getElementById('af-customize-btn');
    if (customizeBtn) {
      customizeBtn.addEventListener('click', function () {
        if (!_validateActiveCustomQuantity()) return;
        if (!_validateDealState()) return;
        _openModal({
          shape: _state.shape,
          fragrance: _state.fragrance,
          printStyle: _state.printStyle,
          quantity: _state.quantity
        });
      });
    }

    _updateFragranceSummary();
    _updatePriceDisplay();
  }

  function _updateQtyPresetHighlight() {
    var presets = document.querySelectorAll('#af-qty-presets .af-widget__preset');
    var customQtyWrap = document.getElementById('af-custom-qty');
    var isCustom = customQtyWrap && customQtyWrap.style.display !== 'none';
    presets.forEach(function (btn) {
      var qtyVal = btn.dataset.qty;
      if (qtyVal === 'custom') {
        btn.classList.toggle('af-widget__preset--active', isCustom);
      } else {
        var v = parseInt(qtyVal, 10);
        btn.classList.toggle('af-widget__preset--active', !isCustom && v === _state.quantity);
      }
    });
  }

  function _showCustomQtyInput() {
    var customQtyWrap = document.getElementById('af-custom-qty');
    var qtyInput = document.getElementById('af-qty-input');
    if (customQtyWrap) customQtyWrap.style.display = 'block';
    if (qtyInput) {
      _configureCustomQuantityInput(qtyInput);
      qtyInput.setCustomValidity('');
      qtyInput.value = _state.quantity;
      qtyInput.focus();
    }
    _updateQtyPresetHighlight();
  }

  function _formatCurrency(val) {
    return '$' + val.toFixed(2);
  }

  function _updatePricingList() {
    var list = document.getElementById('af-pricing-list');
    if (!list || (_dealRecipe && _dealRecipe.key === 'BOGO')) return;
    list.innerHTML = '';
    var tiers = _productContractRow ? _productContractRow.quantities : [];
    var surcharges = _getAfSurcharges();
    var surchargeDollars = surcharges.totalSurchargeCents / 100;
    tiers.forEach(function (qty) {
      var pricing = getPricing(qty);
      if (!pricing) return;
      var tierTotal = pricing.total + surchargeDollars;
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'af-widget__pricing-item' + (qty === _state.quantity ? ' af-widget__pricing-item--active' : '');
      item.innerHTML =
        '<span class="af-widget__pricing-qty">' + qty.toLocaleString() + ' air fresheners</span>' +
        '<span class="af-widget__pricing-prices">' +
        '<span class="af-widget__pricing-total">' + _formatCurrency(tierTotal) + '</span>' +
        '<span class="af-widget__pricing-unit">(' + _formatCurrency(pricing.unitPrice) + ' ea)</span>' +
        '</span>';
      item.addEventListener('click', function () {
        _state.quantity = qty;
        _updateQtyPresetHighlight();
        _updatePriceDisplay();
        _updatePricingList();
      });
      list.appendChild(item);
    });
  }

  async function _transitionToBuilderDual() {
    var frontFile = _state._dualFrontFile;
    if (!frontFile) return;

    var processing = document.getElementById('zug-af-upload-processing');
    var continueBtn = document.getElementById('zug-af-upload-continue');
    if (processing) processing.style.display = 'block';
    var uploadLoader = processing ? processing.querySelector('.zug-preview-loader') : null;
    if (uploadLoader) uploadLoader.classList.add('active');
    if (continueBtn) continueBtn.disabled = true;

    var isRasterFront = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp'].indexOf(frontFile.type) !== -1;

    if (isRasterFront) {
      try {
        var dataUrl = await _readFileAsDataURL(frontFile);
        _state.front.file = frontFile;
        _state.front.fileName = frontFile.name;
        _state.front.imageUrl = dataUrl;
        _state.front.originalDataUrl = dataUrl;

        if (_state.shape === 'die_cut') {
          var dcfResult = await _callDCFPreview(frontFile);
          if (dcfResult) {
            _applyDCFResponse(dcfResult);
            _state.front.imageUrl = _state.previewUrl || dataUrl;
          }
        } else {
          await _renderSimpleShapePreview();
        }
      } catch (err) {
        console.error('[ZUG-AF] dual front processing error:', err);
      }
    } else {
      _state.front.file = frontFile;
      _state.front.fileName = frontFile.name;
      _state.front.imageUrl = null;
    }

    var backFile = _state._dualBackFile;
    if (backFile) {
      var isRasterBack = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp'].indexOf(backFile.type) !== -1;
      _state.back.file = backFile;
      _state.back.fileName = backFile.name;
      if (isRasterBack) {
        try {
          var backDataUrl = await _readFileAsDataURL(backFile);
          _state.back.imageUrl = backDataUrl;
          var backImg = new Image();
          backImg.src = backDataUrl;
          backImg.onload = function () {
            _state._backImgDims = { w: backImg.naturalWidth, h: backImg.naturalHeight };
          };
        } catch (err) {
          console.error('[ZUG-AF] dual back processing error:', err);
        }
      }
    }

    if (processing) processing.style.display = 'none';
    if (uploadLoader) uploadLoader.classList.remove('active');

    var container = document.querySelector('.zug-af-modal__container');
    var stepUpload = document.getElementById('zug-af-step-upload');
    var stepBuilder = document.getElementById('zug-af-step-builder');

    if (stepUpload) stepUpload.style.display = 'none';
    if (container) {
      container.classList.add('zug-af-modal__container--builder');
      container.classList.add('zug-modal__container--builder');
    }
    if (stepBuilder) stepBuilder.style.display = '';

    var removeBgCheckbox = document.getElementById('zug-af-remove-bg');
    if (removeBgCheckbox) removeBgCheckbox.checked = _state.dieCut.removeBg;

    var approveCheck = document.getElementById('zug-af-approve-check');
    if (approveCheck) approveCheck.checked = false;

    _syncBackPanelVisibility();
    _syncBuilderShapeButtons();
    _switchPanel('shape');

    var frontDisplay = _state.previewUrl || _state.front.imageUrl;
    if (frontDisplay) _showPreviewImage(frontDisplay);

    if (_state.shape !== 'die_cut') {
      _initFrontPlacementEditor();
    }

    _syncSideToggle();
    _updateCutlineOverlay();
    _updateStatusBar();
    _updateGating();
    _positionHangingOverlays(true);

    console.log('[ZUG-AF] transitioned to builder (dual)', _state);
  }

  function _initDualUpload() {
    ['front', 'back'].forEach(function (side) {
      var input = document.getElementById('zug-af-dual-input-' + side);
      var removeBtn = document.getElementById('zug-af-dual-' + side + '-remove');

      if (input) {
        input.addEventListener('change', function (e) {
          if (e.target.files && e.target.files[0]) {
            _handleDualUploadFile(side, e.target.files[0]);
          }
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          _removeDualUploadFile(side);
        });
      }
    });
  }

  function _handleDualUploadFile(side, file) {
    if (!file) return;
    if (side === 'front') {
      _state._dualFrontFile = file;
    } else {
      _state._dualBackFile = file;
    }

    var slot = document.getElementById('zug-af-dual-slot-' + side);
    var empty = document.getElementById('zug-af-dual-' + side + '-empty');
    var done = document.getElementById('zug-af-dual-' + side + '-done');
    var nameEl = document.getElementById('zug-af-dual-' + side + '-name');

    if (slot) slot.classList.add('is-complete');
    if (empty) empty.style.display = 'none';
    if (done) done.style.display = '';
    if (nameEl) nameEl.textContent = file.name;

    _updateUploadContinueState();
    console.log('[ZUG-AF] dual upload file set:', side, file.name);
  }

  function _removeDualUploadFile(side) {
    if (side === 'front') {
      _state._dualFrontFile = null;
    } else {
      _state._dualBackFile = null;
    }

    var slot = document.getElementById('zug-af-dual-slot-' + side);
    var empty = document.getElementById('zug-af-dual-' + side + '-empty');
    var done = document.getElementById('zug-af-dual-' + side + '-done');
    var input = document.getElementById('zug-af-dual-input-' + side);

    if (slot) slot.classList.remove('is-complete');
    if (empty) empty.style.display = '';
    if (done) done.style.display = 'none';
    if (input) input.value = '';

    _updateUploadContinueState();
    console.log('[ZUG-AF] dual upload file removed:', side);
  }

  function _dataURLtoBlob(dataUrl) {
    try {
      var parts = dataUrl.split(',');
      var mime = parts[0].match(/:(.*?);/)[1];
      var bstr = atob(parts[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      for (var i = 0; i < n; i++) u8arr[i] = bstr.charCodeAt(i);
      return new Blob([u8arr], { type: mime });
    } catch (err) {
      console.error('[ZUG-AF] dataURL to blob failed:', err);
      return null;
    }
  }

  function _generateRenderedPreview(side) {
    return new Promise(function (resolve) {
      if (side === 'front' && _state._frontEditor && _state._frontEditorReady) {
        try {
          var editor = _state._frontEditor;
          editor.setMode('done');
          var handler = editor._afterRenderHandler;
          if (handler) editor.canvas.off('after:render', handler);
          editor.canvas.requestRenderAll();
          var bbox = editor.cfg.mask && editor.cfg.mask.bbox;
          var exportOpts = { format: 'png' };
          if (bbox) {
            exportOpts.left = bbox.x;
            exportOpts.top = bbox.y;
            exportOpts.width = bbox.w;
            exportOpts.height = bbox.h;
          }
          var dataUrl = editor.canvas.toDataURL(exportOpts);
          if (handler) editor.canvas.on('after:render', handler);
          resolve(dataUrl);
        } catch (err) {
          console.error('[ZUG-AF] front editor toDataURL failed:', err);
          resolve(null);
        }
        return;
      }
      if (side === 'back' && _state.printStyle === 'double' && _state._backEditor && _state._backEditorReady) {
        try {
          var editor = _state._backEditor;
          editor.setMode('done');
          var handler = editor._afterRenderHandler;
          if (handler) editor.canvas.off('after:render', handler);
          editor.canvas.requestRenderAll();
          var bbox = editor.cfg.mask && editor.cfg.mask.bbox;
          var exportOpts = { format: 'png' };
          if (bbox) {
            exportOpts.left = bbox.x;
            exportOpts.top = bbox.y;
            exportOpts.width = bbox.w;
            exportOpts.height = bbox.h;
          }
          var dataUrl = editor.canvas.toDataURL(exportOpts);
          if (handler) editor.canvas.on('after:render', handler);
          resolve(dataUrl);
        } catch (err) {
          console.error('[ZUG-AF] back editor toDataURL failed:', err);
          resolve(null);
        }
        return;
      }

      var src = null;
      if (side === 'back') {
        src = _state.back.renderedSnapshot || _state.back.mirroredDataUrl || _state.back.imageUrl;
      } else {
        src = _state.previewUrl || _state.front.imageUrl;
      }
      if (!src) { resolve(null); return; }

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var c = document.createElement('canvas');
        var maxDim = 800;
        var scale = Math.min(maxDim / img.naturalWidth, maxDim / img.naturalHeight, 1);
        c.width = Math.round(img.naturalWidth * scale);
        c.height = Math.round(img.naturalHeight * scale);
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, c.width, c.height);
        resolve(c.toDataURL('image/png'));
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function _initModal() {
    var modal = document.getElementById('zug-af-modal');
    if (!modal) return;

    modal.querySelectorAll('[data-action="close"]').forEach(function (el) {
      el.addEventListener('click', _closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') _closeModal();
    });

    var methodCards = document.querySelectorAll('.zug-af-method-card');
    methodCards.forEach(function (card) {
      card.addEventListener('click', function () {
        methodCards.forEach(function (c) { c.classList.remove('zug-af-method-card--active'); });
        card.classList.add('zug-af-method-card--active');
        _uploadMethod = card.dataset.method;

        var instantPanel = document.getElementById('zug-af-method-instant');
        var emailPanel = document.getElementById('zug-af-method-email');
        var reorderPanel = document.getElementById('zug-af-method-reorder');
        if (instantPanel) instantPanel.style.display = _uploadMethod === 'instant_proof' ? '' : 'none';
        if (emailPanel) emailPanel.style.display = _uploadMethod === 'email_later' ? '' : 'none';
        if (reorderPanel) reorderPanel.style.display = _uploadMethod === 'reorder' ? '' : 'none';

        _updateUploadContinueState();
      });
    });

    var initialInput = document.getElementById('zug-af-input-initial');
    if (initialInput) {
      initialInput.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0]) {
          _handleUploadStepFile(e.target.files[0]);
        }
      });
    }

    var initialZone = document.getElementById('zug-af-upload-zone-initial');
    if (initialZone) {
      initialZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        initialZone.classList.add('is-dragover');
      });
      initialZone.addEventListener('dragleave', function () {
        initialZone.classList.remove('is-dragover');
      });
      initialZone.addEventListener('drop', function (e) {
        e.preventDefault();
        initialZone.classList.remove('is-dragover');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          _handleUploadStepFile(e.dataTransfer.files[0]);
        }
      });
    }

    var removeBtn = document.getElementById('zug-af-upload-remove');
    if (removeBtn) removeBtn.addEventListener('click', _removeUploadStepFile);

    var reorderNumberInput = document.getElementById('zug-af-reorder-number');
    if (reorderNumberInput) {
      reorderNumberInput.addEventListener('input', function () {
        _updateUploadContinueState();
      });
    }

    var continueBtn = document.getElementById('zug-af-upload-continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (_uploadMethod === 'email_later') {
          _state._emailLater = true;
          _closeModal();
          _addToCartEmailLater();
          return;
        }
        if (_uploadMethod === 'reorder') {
          _closeModal();
          _addToCartReorder();
          return;
        }
        if (_state.printStyle === 'double') {
          _transitionToBuilderDual();
        } else {
          _transitionToBuilder();
        }
      });
    }

    var skipBtn = document.getElementById('zug-af-upload-skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        _closeModal();
      });
    }

    var submitBtn = document.getElementById('zug-af-confirm-submit');
    if (submitBtn) submitBtn.addEventListener('click', _addToCart);

    var approveCheck = document.getElementById('zug-af-approve-check');
    if (approveCheck) {
      approveCheck.addEventListener('change', function () {
        _state.approved = approveCheck.checked;
        _updateGating();
      });
    }

    var afModal = document.getElementById('zug-af-modal');
    var cancelConfirmBtn = afModal ? afModal.querySelector('[data-action="cancel-confirm"]') : null;
    if (cancelConfirmBtn) {
      cancelConfirmBtn.addEventListener('click', function () {
        var container = document.querySelector('.zug-af-modal__container');
        var stepUpload = document.getElementById('zug-af-step-upload');
        var stepBuilder = document.getElementById('zug-af-step-builder');
        if (container) {
          container.classList.remove('zug-af-modal__container--builder');
          container.classList.remove('zug-modal__container--builder');
        }
        if (stepBuilder) stepBuilder.style.display = 'none';
        if (stepUpload) stepUpload.style.display = '';
        var titleEl = document.getElementById('zug-af-modal-title');
        if (titleEl) titleEl.textContent = 'Upload Your Artwork';
      });
    }

    var proofPills = document.querySelectorAll('#zug-af-proof-pills .zug-builder__proof-pill');
    var proofNote = document.getElementById('zug-af-proof-note');
    var approveCheck = document.getElementById('zug-af-approve-check');
    var acceptLabel = document.getElementById('zug-af-accept-label');
    var approvalHelper = document.getElementById('zug-af-approval-helper');
    var confirmSubmitBtn = document.getElementById('zug-af-confirm-submit');
    proofPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        proofPills.forEach(function (p) { p.classList.remove('zug-builder__proof-pill--active'); });
        pill.classList.add('zug-builder__proof-pill--active');
        var commentPop = document.getElementById('zug-af-comment-popover');
        var isComment = pill.dataset.proof === 'comment';
        if (commentPop) commentPop.style.display = isComment ? '' : 'none';
        if (isComment && approveCheck) {
          approveCheck.checked = false;
          _state.approved = false;
        }
        if (acceptLabel) acceptLabel.textContent = isComment
          ? 'I understand a new proof is required before production.'
          : 'I have reviewed my artwork';
        if (approvalHelper) approvalHelper.textContent = isComment
          ? 'We’ll make this change and send you a new proof. Production begins after you approve the updated proof.'
          : 'By approving, you confirm layout, cut line, size, and print quality as shown.';
        if (confirmSubmitBtn) confirmSubmitBtn.textContent = isComment ? 'Submit Changes' : 'Continue to Add to Cart';
        _updateGating();
      });
    });
    if (proofNote) {
      proofNote.addEventListener('input', function () {
        if (proofNote.value.trim() && approveCheck) {
          approveCheck.checked = false;
          _state.approved = false;
        }
        _updateGating();
      });
    }

    _wireUploadInput('front');
    _wireUploadInput('back');
    _wireUploadZoneDragDrop('front');
    _wireUploadZoneDragDrop('back');
    _wireEditorToolbar('front');
    _wireEditorToolbar('back');
    _wireDieCutTools();
    _wireFillRadios();
    _wireBorderPresets();
    _wireShapeButtons();

    var pqInfoBtn = document.getElementById('zug-af-pq-info-btn');
    var pqInfoPop = document.getElementById('zug-af-pq-info-popover');
    if (pqInfoBtn && pqInfoPop) {
      pqInfoBtn.addEventListener('click', function () {
        pqInfoPop.style.display = pqInfoPop.style.display === 'none' ? '' : 'none';
      });
    }

    var dpiInfoBadge = document.getElementById('zug-af-dpi-badge');
    var dpiPopover = document.getElementById('zug-af-dpi-popover');
    if (dpiInfoBadge && dpiPopover) {
      dpiInfoBadge.addEventListener('click', function () {
        dpiPopover.style.display = dpiPopover.style.display === 'none' ? '' : 'none';
      });
    }

    var bgSwatches = document.querySelectorAll('#zug-af-bg-presets .zug-builder__bg-swatch');
    bgSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        bgSwatches.forEach(function (s) { s.classList.remove('zug-builder__bg-swatch--active'); });
        swatch.classList.add('zug-builder__bg-swatch--active');
        var bg = swatch.dataset.bg;
        var canvasArea = document.querySelector('#zug-af-step-builder .zug-builder__preview-canvas');
        if (canvasArea) canvasArea.style.background = bg;
        var disclaimer = document.getElementById('zug-af-disclaimer');
        if (disclaimer) {
          var isDark = _isColorDark(bg);
          disclaimer.style.color = isDark ? 'rgba(255,255,255,0.6)' : '';
        }
      });
    });

    var sideToggle = document.getElementById('zug-af-side-toggle');
    if (sideToggle) {
      sideToggle.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-side]');
        if (chip) _switchPreviewSide(chip.dataset.side);
      });
    }

    var reviewSideToggle = document.getElementById('zug-af-review-side-toggle');
    if (reviewSideToggle) {
      reviewSideToggle.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-side]');
        if (!chip) return;
        var targetSide = chip.dataset.side;
        if (targetSide === 'back' && !_hasBackPreview()) return;
        _state.activeSide = targetSide;
        _syncSideToggle();
        _updateReviewPanel();
      });
    }

    _initDualUpload();
  }

  function _init() {
    var widget = document.getElementById('air-freshener-widget');
    if (!widget) return;
    var tags = widget.getAttribute('data-zug-tags') || '';
    var dealRequested = widget.getAttribute('data-af-deal-requested') === 'true';
    var bogoRequested = widget.getAttribute('data-af-bogo-requested') === 'true';
    try {
      _dealRecipe = window.ZUGAirFreshenerDealRecipes
        ? window.ZUGAirFreshenerDealRecipes.resolve(tags)
        : null;
    } catch (dealError) {
      console.error('[ZUG-AF-DEAL] activation failed closed', dealError);
      return;
    }
    if (dealRequested !== Boolean(_dealRecipe) ||
        bogoRequested !== Boolean(_dealRecipe && _dealRecipe.key === 'BOGO')) {
      console.error('[ZUG-AF-DEAL] Liquid and recipe activation did not agree.');
      return;
    }
    _sampleRequested = Boolean(window.ZUGSampleMode && window.ZUGSampleMode.isActive(tags));
    if (_sampleRequested && _dealRecipe) {
      console.error('[ZUG-AF] sample and deal modes cannot be combined.');
      return;
    }
    var sampleReady = _sampleRequested
      ? window.ZUGSampleMode.load(widget.getAttribute('data-zug-sample-pricing-url'))
      : Promise.resolve(null);
    Promise.all([_loadFragranceConfig(), _fetchNativeRateContract(), _fetchProductContract(), sampleReady]).then(function (results) {
      if (_sampleRequested) {
        _sampleOffer = window.ZUGSampleMode.resolve(results[3], tags, 'air_freshener');
        if (!_sampleOffer) {
          console.error('[ZUG][SAMPLE] No unique Air Freshener sample offer matches this product.');
          return;
        }
      }
      _syncFragranceState();
      _renderFragranceButtons();
      _updateFragranceSummary();
      _initWidget();
      _applyDealUi(widget);
      if (_sampleOffer) {
        _state.quantity = Number(_sampleOffer.quantity);
        _state.shape = _sampleOffer.shape || _state.shape;
        _state.fragrance = _sampleOffer.fragrance || _state.fragrance;
        _state.selectedFragrances = [_state.fragrance];
        _state.printStyle = _sampleOffer.print_style || _state.printStyle;
        _syncFragranceState();
        _updateFragranceSummary();

        window.ZUGSampleMode.lockFamilyUI({
          root: widget,
          family: 'air_freshener',
          state: _state,
          offer: _sampleOffer,
          pendingClass: 'af-widget--sample-pending',
          activeClass: 'af-widget--sample'
        });
      }
      _initModal();
      _updatePriceDisplay();
      console.log('[ZUG-AF] initialized (' + FRAGRANCES.length + ' fragrances, native-rates=' + (_nativeRateContract ? 'ready' : 'missing') + ', product=' + (_productContractRow ? _productContractRow.kind : 'missing') + ')');
    }).catch(function (error) {
      console.error('[ZUG-AF] initialization failed closed', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _init);
  } else {
    _init();
  }

  window.ZUGAirFreshenerModal = {
    open: _openModal,
    close: _closeModal,
    getState: function () { return _state; },
    getPricing: getPricing,
    SHAPES: SHAPES,
    FRAGRANCES: FRAGRANCES
  };

  console.log('[ZUG-AF] module loaded');
})();
